import _get from "lodash/get";
import {
  displayValueWithoutSymbol,
  getDiscountValue,
  getDiscountValueWithoutPercentage
} from '../../utils/price';
import { readCookie, readCohortValueCookie, ManageCookies, readClusterCookie } from '../../components/common/Cookie';
import { getPageInfo, getPageNameForGA, readQueryParameter, getPageInfoForGTM } from '../../utils/pageInfo';
import isNode from '../ajio-util/isNode';
import { catalogIdToStoreName, ENUM } from '../../utils';
import {
  getReleaseGA4Flag,
  getMasterGA4Flag,
  getMasterGA3Flag,
  getEnableLinkCohort,
  getGA4AJIOEnable,
  getUserRelevancy,
  getSegmentTrackingEnabledFlag,
  getCopilotEnabledMsiteFlag,
  getCopilotEnabledDesktopFlag,
  getGSTFlag,
  getPlaAdsClientID,
  getBannerOsmosAdsConfig
} from '../../refresh/selectors/featureFlagsSelector';
import { getFeatureVariant } from '../../refresh/organism/ABFeature/Feature';
import { FLEEK_STORE } from '../../constants/constant';
import UTILS from '../../utils/jioAdsUtils';
import {
  getValidAttributionToken,
  trackCopilotMap,
  getStoredPageCategory,
  getCrossSellWidgetSource
} from '../../utils/common';
import { analytics } from './segment/segment'
import { isMobile } from '../../refresh/utils/deviceTypeUtils';
import { getAmplitudeVariantPayload, getAmplitudeExperimentVariant } from '../../utils/amplitudeCommon';
import { setCookie } from '../../refresh/utils/cookie'
import { storageAvailable } from '../../components/common/storageAvailable';
import { setAffiliateCookie } from '../../utils/affiliateUtils';
import { isCompanionProduct } from "../../utils/companionUtils";

const getPlaItemByCode = (code='') => {
    if (!storageAvailable('localStorage') || !code) return null;
    const PLA_PRODUCTS_STORAGE_KEY = 'osmosPlaProducts';

    try {
      const items = JSON.parse(localStorage.getItem(PLA_PRODUCTS_STORAGE_KEY) || '[]');

      if (!Array.isArray(items)) return null;

      return items.find(item => item.code === code) || null;
    } catch (err) {
      return null;
    }
};
const getPlaItemByProductCode = (code='') => {
    if (!storageAvailable('localStorage') || !code) return null;
    const PLA_PRODUCTS_STORAGE_KEY = 'osmosPlaProducts';

    try {
      const items = JSON.parse(localStorage.getItem(PLA_PRODUCTS_STORAGE_KEY) || '[]');

      if (!Array.isArray(items)) return null;

      return items.find(item => item.productCode === code) || null;
    } catch (err) {
      return null;
    }
};
  
const storage = new ManageCookies();

const segmentTrackingEnabled = getSegmentTrackingEnabledFlag(window?.__PRELOADED_STATE__?.flags);

function getStoreType(arr = []) {
  const storeType = [...new Set(arr)];
  return storeType.join(',');
}
export function getStoreName() {
  const Host = window?.location?.href || '';
  if (window?.__PRELOADED_STATE__?.metaData?.name) {
    return window?.__PRELOADED_STATE__?.metaData?.name;
  }
  if (
    Host != '' &&
    !Host.toLowerCase().includes('uat.') &&
    !Host.toLowerCase().includes('qa.') &&
    (Host.toLowerCase().includes('ajio.com') ||
      Host.toLowerCase().includes('ril.com') ||
      Host.toLowerCase().includes('web.ajio.com'))
  ) {
    let storeValue = '';
    storeValue = Host.replace(
      /(http(s){0,1}:\/\/)*((w){3,}.)*([a-z]*[0-9]{0,}-)*((.web){0,}(.services){0,}(.ajio){0,}(.ril){0,}.com(.*)){0,}/gi,
      ''
    );
    return storeValue;
  }
  return 'ajio';
}

export function getCurrentStoreType() {
  const storeName = getStoreName();
  const lowercasedStoreName = (storeName || '').toLowerCase();

  if (lowercasedStoreName === 'luxe' || lowercasedStoreName === 'ajiogram' || lowercasedStoreName === 'ajio') {
    return lowercasedStoreName;
  }

  return 'ajio';
}

export function getSisStore() {
  const storeName = getStoreName();
  const lowercasedStoreName = (storeName || '').toLowerCase();

  if (lowercasedStoreName === 'luxe' || lowercasedStoreName === 'ajiogram' || lowercasedStoreName === 'ajio') {
    return '';
  }

  return lowercasedStoreName;
}

export function getUserUUID() {
  const userUUID = readCookie('EI');
  return userUUID ? decodeURIComponent(userUUID) : '';
}


export function getPLPTypeOfRedirection(pathname = '') {
  const redirects = {
    '/search': 'search',
    '/c': 'c',
    '/s': 's'
  };

  for (const path in redirects) {
    if (pathname.includes(path)) {
      return redirects[path];
    }
  }
  return '';
}

export function getUserTempId() {
  const userTempId = readCookie('deviceId');
  return userTempId ? decodeURIComponent(userTempId) : '';
}

export function getSkuAutoSelectSizeData(size) {
  const sizeSelect = sessionStorage.getItem('defaultSKUSizeSelection');
  return sizeSelect ? `${sizeSelect}_${size}` : size;
}
function getCustSegmentIds() {
  return readCookie('cohortSegment') || '';
}

function getCohortIds(store, serviceName) {
  const newStoreVal = store === 'AJIO' ? 'rilfnl' : store;
  return readCohortValueCookie('userCohortValues', newStoreVal, serviceName);
}

function gtmFixedpram() {
  const user_status = readCookie('U') || 'anonymous';
  const login_type = user_status !== 'anonymous' ? 'logged in' : ' not logged In';
  return {
    user_id: getUserUUID(),
    contains_store: getStoreName(),
    store_type: getStoreName(),
    pricing_cust_seg: getCustSegmentIds(),
    login_type,
    ...getPageUserInfo()
  };
}

function getPageUserInfo() {
  if (isNode()) return {};
  let user_status = readCookie('U') || 'anonymous';
  let user_ga;
  let user_base_category;
  const refered_Page = document?.referrer;
  const data = (localStorage && JSON.parse(localStorage.getItem('customerTypeData'))) || {};
  const isExcisting = data ? data.customerType === 'Existing' : false;
  const user_type = isExcisting ? 'Existing' : 'New';
  if (user_status !== 'anonymous') {
    user_status = decodeURIComponent(user_status);
    return {
      user_status: 'loggedin',
      user_type,
      user_ga: readCookie('_ga'),
      user_base_category: localStorage?.getItem('categoryPath'),
      refered_Page
    };
  }
  return {
    user_status: 'guest',
    refered_Page,
    user_type
  };
}

function getPageUserInfoForSegment() {
  if (isNode()) return {};
  let user_status = readCookie('U') || 'anonymous';
  let user_ga;
  let user_base_category;
  const refered_Page = document?.referrer;
  const data = (localStorage && JSON.parse(localStorage.getItem('customerTypeData'))) || {};
  const isExcisting = data ? data.customerType === 'Existing' : false;
  const user_type = isExcisting ? 'Existing' : 'New';
  if (user_status !== 'anonymous') {
    user_status = decodeURIComponent(user_status);
    return {
      loggedin_status: 'loggedin',
      loggedin_type: user_type,
      //user_ga: readCookie('_ga'),
      //user_base_category: localStorage?.getItem('categoryPath'),
      //page_url: refered_Page
    };
  }
  return {
    loggedin_status: 'guest',
    //page_url: refered_Page,
    loggedin_type: user_type,
  };
}

function checkGtmDatalayerExistStatus() {
  return !!(window && window.dataLayer);
}

function setUserStatus() {
  if (isNode()) return '';
  const user_status = readCookie('U') || 'anonymous';
  if (user_status !== 'anonymous') return 'loggedin';
  return 'guest';
}

export function gtmDatalayerPushData(obj, exceptionTitle) {
  try {
    if (checkGtmDatalayerExistStatus()) {
      if ('is_GA4' in obj && obj.is_GA4 === false) {
        delete obj.is_GA4;
      }
      const { pageType } = getPageInfo(
        window.location.pathname || '',
        false,
        obj?.store_type.toLowerCase() === FLEEK_STORE.toLowerCase()
      );
      const { pageName } = getPageNameForGA(
        window.location.pathname || '',
        false,
        obj?.store_type.toLowerCase() === FLEEK_STORE.toLowerCase()
      );
      obj = {
        ...obj,
        page_type: obj.page_type ? obj.page_type : pageType,
        page_name: obj.page_name ? obj.page_name : pageName
      };

      if (obj.hasOwnProperty('event_category') || obj.hasOwnProperty('eventCategory')) {
        obj.category = obj.event_category || obj.eventCategory;
        delete obj.event_category;
        delete obj.eventCategory;
      }

      if (obj.hasOwnProperty('event_action') || obj.hasOwnProperty('eventAction')) {
        obj.action = obj.event_action || obj.eventAction;
        delete obj.event_action;
        delete obj.eventAction;
      }

      if (obj.hasOwnProperty('event_label') || obj.hasOwnProperty('eventLabel')) {
        obj.label = obj.event_label || obj.eventLabel;
        delete obj.event_label;
        delete obj.eventLabel;
      }

      if (obj.event === 'pageload' && !obj.user_status) {
        obj.user_status = setUserStatus();
      }

      const ga4AjioEnable = getGA4AJIOEnable(window?.__PRELOADED_STATE__?.flags);
      if (ga4AjioEnable) {
        if (obj.event === 'pageload') obj.event = 'page_view';
        obj.isGA4 = true;
      }

      const userHybrisId = getUserUUID();
      if (userHybrisId) obj.user_hybris_id = userHybrisId;

      const userTempId = getUserTempId();
      if (userTempId) obj.user_temp_id = userTempId;
      obj.build_number = '25_11_0';

      if (obj?.event === 'ai_assistant_widget_interactions' || obj?.ecommerce?.item_list_name === 'ai_assistant_widget') {
        console.log('[copilot] gtmEventPush ~ obj:', obj)
      }
      window.dataLayer.push(obj);

    }
  } catch (e) {
    console.log(`${exceptionTitle} - Exception: ${e.message}`);
  }
}

let _lastPageViewedUrl = '';

export function segmentDatalayerPushData(obj, exceptionTitle) {
  try { 
      
      delete obj.is_GA4;      
      const { pageType } = getPageInfo(
        window.location.pathname || '',
        false,
        obj?.store_type?.toLowerCase() === FLEEK_STORE.toLowerCase()
      );
      const { pageName } = getPageNameForGA(
        window.location.pathname || '',
        false,
        obj?.store_type?.toLowerCase() === FLEEK_STORE.toLowerCase()
      );
      const _urlParams = new URLSearchParams(window.location.search);
      const _isTrendWidget = _urlParams.get('isTrendWidget') === 'true';
      const _resolvedScreenName = _isTrendWidget
        ? 'widget_plp_screen'
        : obj.page_name ? obj.page_name : (obj.screen_name || pageName);
      obj = {
        ...obj,
        page_type: obj.page_type ? obj.page_type : pageType,
        screen_name: _resolvedScreenName
      };
      delete obj.page_name;

      if (obj.hasOwnProperty('event_category') || obj.hasOwnProperty('eventCategory')) {
        //obj.category = obj.event_category || obj.eventCategory;
        delete obj.event_category;
        delete obj.eventCategory;
      }

      if (obj.hasOwnProperty('event_action') || obj.hasOwnProperty('eventAction')) {
        //obj.action = obj.event_action || obj.eventAction;
        delete obj.event_action;
        delete obj.eventAction;
      }

      if (obj.hasOwnProperty('event_label') || obj.hasOwnProperty('eventLabel')) {
        //obj.label = obj.event_label || obj.eventLabel;
        delete obj.event_label;
        delete obj.eventLabel;
      }

      if (obj.event === 'pageload' && !obj.user_status) {
        obj.user_status = setUserStatus();
      }

      
      const userHybrisId = getUserUUID();
      //if (userHybrisId) obj.user_hybris_id = userHybrisId;

      //const userTempId = getUserTempId();
      //if (userTempId) obj.user_temp_id = userTempId;
      //obj.build_number = '25_11_0';

     // window.dataLayer.push(obj);

      const hit_numner = sessionStorage.getItem("hit_number") !== null ? parseInt(sessionStorage.getItem("hit_number")) : 0;
      sessionStorage.setItem("hit_number",hit_numner+1);

      obj.is_entrance_flag = checkEntranceFlag(); //if referer other than ajio.com or missing 
      if (!obj.previous_screen_name) {
        obj.previous_screen_name = getPreviousScreenName();
      }
      
    
      //obj.session_id = sessionStorage.getItem("sessionId");
      obj.persona_store_type = readClusterCookie('cluster', name);
     // obj.device_id = readCookie("deviceId");
      //obj.user_id = readCookie("uI");
     // if (userHybrisId) obj.customer_pk = userHybrisId;


      obj.hit_number = hit_numner+1;
      obj.redirection_type = obj.type_of_redirection || obj.redirection_type;
      delete obj.type_of_redirection;
      obj.plp_number_of_results = obj.number_results;
      delete obj.number_results;
    const affiliateFeatureConfig = getAmplitudeVariantPayload(
      'affiliatefeatureconfig',
      window?.__PRELOADED_STATE__,
      window?.__PRELOADED_STATE__?.flags?.affiliateFeatureConfig
    );
    const creatorprogramconfig = getAmplitudeVariantPayload(
      'creatorprogramconfig',
      window?.__PRELOADED_STATE__,
      window?.__PRELOADED_STATE__?.flags?.creatorprogramconfig
    );
    const { utm_medium } = readQueryParameter(window.location);
    if (utm_medium === 'affiliate' && affiliateFeatureConfig?.masterFlag) {
      setAffiliateCookie(affiliateFeatureConfig, creatorprogramconfig);
    } else if (utm_medium === 'creator' && creatorprogramconfig?.masterFlag) {
      setAffiliateCookie(affiliateFeatureConfig, creatorprogramconfig);
    }
      if (obj.event === 'Screen Viewed' && obj.referrer != 'orders') {
        //"number_of_sizes_OOS": 0,
        //"number_of_sizes": 5,
        obj.number_of_size_variant_available = obj.number_of_sizes;
        obj.number_of_size_variant_oos= obj.number_of_sizes_OOS;
        delete obj.number_of_sizes;
        delete obj.number_of_sizes_OOS;
        delete obj.number_of_coupons_shown;
        delete obj.Product_MRP;
        delete obj.product_selling_price;
        delete obj.product_trade_discount;
        delete obj.standard_size_guide;
        delete obj.bbs_widget;
        delete obj.bbs_widget_state;
        delete obj.bbs_banner;
        delete obj.pdp_td;
        delete obj.sale_discount;
        delete obj.sale_delta;
        delete obj.hybris_id;
        delete obj.contains_store;
        delete obj.pricing_cust_seg;
      
        delete obj.user_hybris_id;       
        delete obj.plp_source;
        obj.screen_source_detail = obj.plp_source_details;
        delete obj.plp_source_details;
        if(obj.plp_store_type) {
          obj.store_type = obj.plp_store_type;
          delete obj.plp_store_type;
        }
        delete obj.zero_search_term;
        delete obj.banner_theme_extended;
        delete obj.user_search_term;
        delete obj.page_type;
        delete obj.user_id;
        delete obj.plp_category_id;
        delete obj.bbs_widget_title;

        if(obj.plp_page_title){
          obj.screen_title = obj.plp_page_title;
          delete obj.plp_page_title;
        }
       
        
        delete obj.coupon_available;
        delete obj.coupon_applicable;
        delete obj.store;
        delete obj.supercash_earn;

        if(obj.supercash_balance){
          obj.wallet_points_balance = Number(obj.supercash_balance|| 0);
        }
        if(obj.ajio_cash_balance){
          obj.wallet_cash_balance = Number(obj.ajio_cash_balance || 0);
        }

        delete obj.supercash_balance;
        delete obj.ajio_cash_balance;
        delete obj.coupon_not_applicable;
        delete obj.user_hybris_id;
        
      
       
        const { utm_source, utm_medium, utm_id, utm_campaign, utm_content } = readQueryParameter(window.location);
        obj.traffic_source = utm_source;
        obj.traffic_medium = utm_medium;
        obj.campaign_id = utm_id;
        obj.campaign_name = utm_campaign;
        obj.campaign_content = utm_content;
       // obj.campaign_ad_id = readQueryParameter('utm_medium');;
       // obj.campaign_ad_name = readQueryParameter('utm_medium');;
       // obj.campaign_adset_id = readQueryParameter('utm_medium');;
       // obj.campaign_adset_name =readQueryParameter('utm_medium');;
        if(!obj.store_type){
            obj.store_type = getCurrentStoreType();
        }

        if(!obj.sis_store){
            obj.sis_store = getSisStore();
        }

      if (!obj.store_name) {
        obj.store_name = getStoreName();
      }

        //facebook cookies
        obj.fbp = readCookie('_fbp') || '';
        obj.fbc = readCookie('_fbc') || '';

        const gclid = readQueryParameter(window.location).gclid;
        if (gclid) {
          setCookie('gclid', gclid)
        }

        const fbclid = readQueryParameter(window.location).fbclid;
        if (fbclid) {
          setCookie('fbclid', fbclid)
        }

        const gclidFromCookie = readCookie('gclid') || '';
        const fbclidFromCookie = readCookie('fbclid') || '';

        // Build ad tracking context
        const adTrackingContext = {
          ad_tracking_data: {
            gclid: gclidFromCookie || gclid || "NA",
            fbclid: fbclidFromCookie || fbclid || "NA",
            fbp_id: obj.fbp || "NA",
            fbc_id: obj.fbc || "NA"
          }
        };
     
        const currentUrl = window.location.href;
        if (_lastPageViewedUrl === currentUrl) {
          return;
        }
        _lastPageViewedUrl = currentUrl;
        obj.event = "Page Viewed";
        analytics?.page(obj.event, obj, {
          context: adTrackingContext
        });
      } else {
          let adTrackingContext = {};
          delete obj.referrer;
          if(obj.event == "Product Clicked"){

              // commented out as it is assigning the deleted property page_name to screen_name
              // obj.screen_name = obj.page_name;
              // delete obj.page_name;
              obj.screen_title = obj.plp_page_title;
              delete obj.plp_page_title;
              obj.screen_source = obj.plp_source_details;
              delete obj.plp_source_details;
          }

          if(obj.event == "Coupon Select Clicked"){

            obj.cart_id = readCookie('C');
            //obj.click_cta_name = 'Apply';
          }

          if(obj.event == "Add To Bag Clicked"){
            //facebook cookies
            obj.fbp = readCookie('_fbp') || '';
            obj.fbc = readCookie('_fbc') || '';

            const gclid = readQueryParameter(window.location).gclid;
            if (gclid) {
              setCookie('gclid', gclid)
            }

            const fbclid = readQueryParameter(window.location).fbclid;
            if (fbclid) {
              setCookie('fbclid', fbclid)
            }

            const gclidFromCookie = readCookie('gclid') || '';
            const fbclidFromCookie = readCookie('fbclid') || '';

            // Build ad tracking context
            adTrackingContext = {
              ad_tracking_data: {
                gclid: gclidFromCookie || gclid || "NA",
                fbclid: fbclidFromCookie || fbclid || "NA",
                fbp_id: obj.fbp || "NA",
                fbc_id: obj.fbc || "NA"
              }
            };
          }

          if(obj.event == "Product Wishlisted"){
            //facebook cookies
            obj.fbp = readCookie('_fbp') || '';
            obj.fbc = readCookie('_fbc') || '';

            const gclid = readQueryParameter(window.location).gclid;
            if (gclid) {
              setCookie('gclid', gclid)
            }

            const fbclid = readQueryParameter(window.location).fbclid;
            if (fbclid) {
              setCookie('fbclid', fbclid)
            }

            const gclidFromCookie = readCookie('gclid') || '';
            const fbclidFromCookie = readCookie('fbclid') || '';

            // Build ad tracking context
            adTrackingContext = {
              ad_tracking_data: {
                gclid: gclidFromCookie || gclid || "NA",
                fbclid: fbclidFromCookie || fbclid || "NA",
                fbp_id: obj.fbp || "NA",
                fbc_id: obj.fbc || "NA"
              }
            };
          }

          if(obj.event == "InitiateCheckout"){
            //facebook cookies
            obj.fbp = readCookie('_fbp') || '';
            obj.fbc = readCookie('_fbc') || '';

            const gclid = readQueryParameter(window.location).gclid;
            if (gclid) {
              setCookie('gclid', gclid)
            }

            const fbclid = readQueryParameter(window.location).fbclid;
            if (fbclid) {
              setCookie('fbclid', fbclid)
            }

            const gclidFromCookie = readCookie('gclid') || '';
            const fbclidFromCookie = readCookie('fbclid') || '';

            // Build ad tracking context
            adTrackingContext = {
              ad_tracking_data: {
                gclid: gclidFromCookie || gclid || "NA",
                fbclid: fbclidFromCookie || fbclid || "NA",
                fbp_id: obj.fbp || "NA",
                fbc_id: obj.fbc || "NA"
              }
            };
          }

          if(obj.event == "Pdp Product Image Details"){
            //facebook cookies
            obj.fbp = readCookie('_fbp') || '';
            obj.fbc = readCookie('_fbc') || '';

            const gclid = readQueryParameter(window.location).gclid;
            if (gclid) {
              setCookie('gclid', gclid)
            }

            const fbclid = readQueryParameter(window.location).fbclid;
            if (fbclid) {
              setCookie('fbclid', fbclid)
            }

            const gclidFromCookie = readCookie('gclid') || '';
            const fbclidFromCookie = readCookie('fbclid') || '';

            // Build ad tracking context
            adTrackingContext = {
              ad_tracking_data: {
                gclid: gclidFromCookie || gclid || "NA",
                fbclid: fbclidFromCookie || fbclid || "NA",
                fbp_id: obj.fbp || "NA",
                fbc_id: obj.fbc || "NA"
              }
            };
          }

          if(obj.event == "Purchased"){
            //facebook cookies
            obj.fbp = readCookie('_fbp') || '';
            obj.fbc = readCookie('_fbc') || '';

            const gclid = readQueryParameter(window.location).gclid;
            if (gclid) {
              setCookie('gclid', gclid)
            }

            const fbclid = readQueryParameter(window.location).fbclid;
            if (fbclid) {
              setCookie('fbclid', fbclid)
            }

            const gclidFromCookie = readCookie('gclid') || '';
            const fbclidFromCookie = readCookie('fbclid') || '';

            // Build ad tracking context
            adTrackingContext = {
              ad_tracking_data: {
                gclid: gclidFromCookie || gclid || "NA",
                fbclid: fbclidFromCookie || fbclid || "NA",
                fbp_id: obj.fbp || "NA",
                fbc_id: obj.fbc || "NA"
              }
            };
          }

          if(obj.ecommerce && obj.ecommerce.items){
              obj.products = obj.ecommerce.items;
              delete obj.ecommerce;
          }

          if(!obj.store_type){
            obj.store_type = getCurrentStoreType();
          }

          if(!obj.store_type){
            obj.store_type = getCurrentStoreType();
          }

          if(!obj.sis_store){
            obj.sis_store = getSisStore();
        }

      if (!obj.store_name) {
        obj.store_name = getStoreName();
      }

          delete obj.hybris_id;
          delete obj.user_hybris_id;
          
        analytics?.track(obj.event, obj, {
          ...(adTrackingContext && { context: adTrackingContext })
        });
        
      }    
  } catch (e) {
    console.log(`${exceptionTitle} - Exception: ${e.message}`);
  }
}

export function gtmPagePush(page_name = '', page_type = '', env = '', otherOptions = {}, segmentProps={}) {
  const eventName = 'pageload';
  const { store = 'AJIO', serviceName = '', ...restOtherOptions } = otherOptions;
  const { 
    cart= {}, 
    isAssuredGifts='', 
    internalWallets = {}, 
    coachmark_impression= '', 
    search_term='', 
    search_type='', 
    quick_filter_count='',
    quick_filter_name='',
    ads_enabled_screen_flag='',
    best_coupon_name='',
    best_coupon_discount='',
    current_experience='',
  } = segmentProps;

  const enableUniversalCohortFlow = getAmplitudeVariantPayload('enableUniversalCohortFlow', window?.__PRELOADED_STATE__, false);
  
  restOtherOptions.store_type = store;
  const storeName = getStoreName();
  const linkCohortObj = {};
  const enableLinkCohort = getEnableLinkCohort(window?.__PRELOADED_STATE__?.flags) === 'ON';
  const hasAjioStore =
    String(storeName).toLowerCase() === 'ajio' || String(storeName).toLowerCase() === 'rilfnl';
  if (enableLinkCohort && hasAjioStore) {
    const linkCohort = readCookie('linkCohort');
    const cohortValue =
      readCohortValueCookie('userCohortValues', 'ajio', serviceName, enableUniversalCohortFlow) ||
      readCohortValueCookie('userCohortValues', 'rilfnl', serviceName, enableUniversalCohortFlow);
    const link_param = linkCohort || 'no parameter';
    const current_experience = String(cohortValue || linkCohort)
      .toLowerCase()
      .startsWith('premium')
      ? 'premium'
      : 'non premium';
    linkCohortObj.link_param = link_param || '';
    linkCohortObj.current_experience = current_experience;
    segmentProps.current_experience=current_experience;
  }
  gtmDatalayerPushData(
    {
      event: eventName,
      page_name,
      page_type,
      env,
      ...restOtherOptions,
      ...getPageUserInfo(),
      hybris_id: getUserUUID(),
      contains_store: storeName,
      store_type: storeName,
      pricing_cust_seg: getCustSegmentIds(),
      secondary_user_cohort: getCohortIds(store, serviceName),
      ...linkCohortObj
    },
    'gtmPagePush'
  );

  if(segmentTrackingEnabled == 'ON'){
    
    //ignore this multiple calls
    if(page_type == 'address management screen') return;
    
    const copilotMsiteEnable = getCopilotEnabledMsiteFlag(window?.__PRELOADED_STATE__?.flags);
    const copilotWebEnable = getCopilotEnabledDesktopFlag(window?.__PRELOADED_STATE__?.flags);
    const isMobileDevice = isMobile();
    const copilotEnable = (isMobileDevice ? copilotMsiteEnable : copilotWebEnable) === 'ON';
    if (copilotEnable) {
      let segmentPageType = page_type;
      if (!segmentPageType) {
        const { pageType } = getPageInfoForGTM(window?.location?.pathname, false,
          storeName.toLowerCase() === FLEEK_STORE.toLowerCase());
        segmentPageType = pageType;
      }
      const allowedPageTypeForAIParams = ['home screen', 'plp screen', 'pdp screen', 'SHOP'];
      if (allowedPageTypeForAIParams.includes(segmentPageType)) {
        otherOptions.is_ai_assistant_visible = 'yes';
      };
    }
    segmentPageView(page_name, page_type, env , otherOptions , segmentProps);
  }

}



export function gtmPagePushOrderListing(pagename, pagetype, totalOrders, currentPage, dataRange, segmentProps) {
  try {
    const ga4AjioEnable = getGA4AJIOEnable(window?.__PRELOADED_STATE__?.flags);
    const extraFields = {};
    if (ga4AjioEnable) {
      extraFields.event = 'page_view';
      extraFields.isGA4 = true;
    }

    const { 
      cart= {}, 
      isAssuredGifts='', 
      internalWallets = {}, 
      coachmark_impression= '', 
      search_term='', 
      search_type='', 
      quick_filter_count='',
      quick_filter_name='',
      ads_enabled_screen_flag='',
      best_coupon_name='',
      best_coupon_discount=''
    } = segmentProps;

    const userHybrisId = getUserUUID();
    if (userHybrisId) extraFields.user_hybris_id = userHybrisId;

    const userTempId = getUserTempId();
    if (userTempId) extraFields.user_temp_id = userTempId;

    const { pageName } = getPageNameForGA(
      window.location.pathname || '',
      false,
      getStoreName() === FLEEK_STORE.toLowerCase()
    );

    window
      ? window.dataLayer.push({
          event: 'pageload',
          pagename: pagename || pageName,
          pagetype,
          total_number_of_orders: totalOrders,
          page_number: currentPage,
          date_range: dataRange || 'Last 6 months',
          contains_store: getStoreName(),
          store_type: getStoreName(),
          build_number: '25_10_0',
          ...extraFields
        })
      : console.log('window object not found');

      if(segmentTrackingEnabled == 'ON'){
        segmentPageView(pageName, pagetype, '' , { totalOrders, currentPage , dataRange} , segmentProps);
      }

  } catch (ex) {
    console.log(`gtmPagePushOrderListing - Exception: ${ex.message}`);
  }
}

export function gtmExtraPageInfo(obj) {
  gtmDatalayerPushData({ meta: obj }, 'gtmEventPush');
}

export function gtmExtraInfoMeta(key, value) {
  try {
    if (window) {
      let number = -1;
      window.dataLayer.forEach(function(elem, i) {
        for (const item in elem) {
          if (item == 'meta') {
            number = i;
            return;
          }
          break;
        }
      });
      number == -1
        ? window.dataLayer.push({ meta: { [key]: value } })
        : (window.dataLayer[number].meta[key] = value);
    } else {
      console.log('gtmEventPush: window undefined');
    }
  } catch (ex) {
    console.log(`gtmEventPush - Exception: ${ex.message}`);
  }
}

export function gtmEventPush(obj, customStoreAttr = '') {
  gtmDatalayerPushData(
    {
      ...obj,
      hybris_id: getUserUUID(),
      contains_store: customStoreAttr || getStoreName(),
      store_type: getStoreName(),
      ...getPageUserInfo()
    },
    'gtmEventPush'
  );
}

export function segmentEventPush(obj, customStoreAttr = '') {
  segmentDatalayerPushData(
    {
      ...obj,
      hybris_id: getUserUUID(),
      store_name: customStoreAttr || getStoreName(),
      store_type: getCurrentStoreType(),
      ...getPageUserInfoForSegment()
    },
    'gtmEventPush'
  );
}



export function gtmEventPushPLP(obj, customStoreAttr = '', checkGA4 = false) {
  
  if (checkGA4) {
    const masterGA3 = getMasterGA3Flag() === 'ON';
    const masterGA4 = getMasterGA4Flag() === 'ON';
    const releaseGA4 = getReleaseGA4Flag() === 'ON';
    const isGA4Feature = getFeatureVariant('isGA4Feature');
    const storeName = getStoreName();
    if (!(isGA4Feature === '1' && releaseGA4 && masterGA4 && !masterGA3 && storeName === 'ajio')) {
      return undefined;
    }
  }

  let user_status = readCookie('U') || 'anonymous';
  let login_type = user_status !== 'anonymous' ? 'logged in' : ' not logged In';

  gtmDatalayerPushData(
    {
      ...obj,
      user_id: getUserUUID(),
      hybris_id: getUserUUID(),
      contains_store: getStoreName(),
      store_type: getStoreName(),
      pricing_cust_seg: getCustSegmentIds(),
      login_type,
      ...getPageUserInfo()
    },
    'gtmEventPushPLP'
  );
}

export function gtmProductImpressions(ProductArray) {
  gtmDatalayerPushData(
    {
      event: 'ee-impression',
      ecommerce: {
        currencyCode: 'INR',
        impressions: ProductArray,
        contains_store: getStoreName(),
        store_type: getStoreName()
      }
    },
    'gtmProductImpressions'
  );
}

export function getTrendWidgetItmSourceProps(overrideWidgetName) {
  if (overrideWidgetName) {
    return { itm_source: 'widget', itm_source_detail: overrideWidgetName };
  }
  const urlParams = new URLSearchParams(window.location.search);
  const isTrendWidget = urlParams.get('isTrendWidget') === 'true';
  const widgetName = urlParams.get('widgetName');
  const widgetTitle = urlParams.get('widgetTitle');
  if (!isTrendWidget && !widgetName && !widgetTitle) return {};
  const itm_source_detail = widgetName || widgetTitle || 'trends_plp_widget';
  return { itm_source: 'widget', itm_source_detail };
}

export function gtmListingProductImpressions(
  ProductArray,
  showPlpExtendedBanner,
  plp_source_details,
  isPLPSource,
  searchText,
  previousSource,
  sourcePage = '',
  parentProduct,
  impression_source,
  impression_type,
  token = getValidAttributionToken(),
  itmSourceDetailValue = '',
  pageCategory = '',
  bottomCardFilterValue = []
) {
  const resolvedPageCategory = pageCategory || getStoredPageCategory();
  const resolvedToken = token || getValidAttributionToken();
  const adsDataClickImp = JSON.parse(localStorage.getItem('adsDataClickImp'));
  const getStoreTypeArray =
    ProductArray?.length >= 0
      ? ProductArray
      : ProductArray?.impressions?.length >= 0
      ? ProductArray.impressions
      : [];
  //
  const reduxState = window?.__PRELOADED_STATE__;
  const parentProdData = parentProduct ? parentProduct : ProductArray.parentProduct;
  const userRelevancyFlag = getUserRelevancy(window?.__PRELOADED_STATE__?.flags);
  const ga4AjioEnable = getGA4AJIOEnable(window?.__PRELOADED_STATE__?.flags);
  const isVertexCategoryEnabled= getAmplitudeVariantPayload('enableCategoryWidgetsVertex', reduxState, false) && getAmplitudeExperimentVariant('vertex-exp-flag',reduxState);

  console.log("ga4AjioEnable "+ ga4AjioEnable);
  if (ga4AjioEnable) {
    let itemListName = '';
    let promotionArray = [];
    if (typeof ProductArray === 'object') {
      promotionArray =
        ProductArray.promotionArray || ProductArray.impressions || getStoreTypeArray || [];
    }
    if (promotionArray.length > 0) {
      itemListName = promotionArray[0].list || '';
    }
    let isDressTool = false;
    let dressToolSessionData;
    if (window?.location.search?.includes('dressTool')) {
      isDressTool = true;
      let tempDressToolSessionData = sessionStorage.getItem('dressToolIngressDetails') || {};
      if (tempDressToolSessionData) {
        dressToolSessionData = JSON.parse(tempDressToolSessionData);
      }
    }
    
    const previousSourceValue = window?.location.pathname?.includes('/search') || isVertexCategoryEnabled
      ? `|${previousSource}`
      : '';
    const newObjForGTM = {
      event: 'view_item_list',
      plp_page_title: adsDataClickImp?.plp_page_title ? adsDataClickImp.plp_page_title : searchText,
      contains_store: getStoreName(),
      event_category: 'Enhance E-commerce',
      event_action: 'view_item_list',
      store_type: getStoreName(),
      plp_source_details: itmSourceDetailValue
        || (isDressTool
          ? (dressToolSessionData?.BannerName || plp_source_details)
          : plp_source_details),
      plp_source: isDressTool ? 'bra_dress tool' : isPLPSource,
      isGA4: true,
      ecommerce: {
        item_list_name: sourcePage === 'fleek_curated_plp_screen' ? 'fleek_visit_ajiogram_store' : itemListName,
        items: promotionArray.map(product => {
          const productDiscount =
            (product.wasProductPrice * getDiscountValueWithoutPercentage(product.dimension170)) /
              100 || 0;
          return {
            item_id: product.id,
            item_name: product.name,
            discount: Number(productDiscount) || 0,
            index: Number(product.position) || 0,
            item_brand: product.brand,
            item_list_name: product.list || itemListName,
            item_category: product.category,
            item_variant: product.variant,
            price: Number(product.price) || 0,
            coupon: product.coupon,
            quantity: Number(product.quantity) || 1,
            product_id: product.dimension12,
            product_name: product.dimension13,
            product_category: product.dimension16,
            product_store_type: product.dimension23,
            product_segment: product.dimension36,
            product_portfolio: product.dimension37,
            product_vertical: product.dimension38,
            product_brick: product.dimension39,
            product_view_type: product.dimension41,
            ratings_shown_no_of_users: product.dimension46,
            available_quantity_deliverable_non_deliverable: product.dimension59,
            segment_id_experiment_id: product.dimension60,
            delivery_tag: product.dimension61,
            product_level_edd: product.dimension66,
            jio_ads_campaign_data: product.dimension161,
            prod_jio_ads_listing: product.dimension162,
            jio_ads_option_code: product.dimension163,
            sticker_name: product.dimension165,
            offer_name: product.dimension166,
            wishlish_count: product.dimension167,
            product_discount: product.dimension170,
            product_trade_discount: product.dimension171,
            product_size: product.dimension191,
            ...(token && {
              search_attribution: token
            }),
          };
        })
      },
      banner_theme_extended: showPlpExtendedBanner ? 'yes' : 'no',
      pricing_cust_seg: getCustSegmentIds(),
      type_of_redirection: `${getPLPTypeOfRedirection(
        window?.location?.pathname || ''
      )} ${previousSourceValue}`,
      search_term: searchText || '',
      user_search_term: searchText || '',
      page_type: sourcePage,
      page_name: sourcePage,
      page_category: resolvedPageCategory
    };
    if (isDressTool) {
      newObjForGTM.dress_tool_ingress =
        dressToolSessionData && dressToolSessionData?.IngressPoint
          ? dressToolSessionData?.IngressPoint
          : '';
    }

    gtmDatalayerPushData(newObjForGTM, 'gtmListingProductImpressions');
    
    

  } else {
    if (Array.isArray(ProductArray)) {
      ProductArray.forEach(p => delete p.wasProductPrice);
    }
    gtmDatalayerPushData(
      {
        event: 'ee_product_impressions',
        plp_page_title: adsDataClickImp?.plp_page_title
          ? adsDataClickImp.plp_page_title
          : searchText,
        contains_store: getStoreType(getStoreTypeArray?.map(el => el.dimension23)),
        store_type: getStoreName(),
        plp_source_details,
        plp_source: isPLPSource,
        ecommerce: {
          currencyCode: 'INR',
          impressions: ProductArray
        },
        banner_theme_extended: showPlpExtendedBanner ? 'yes' : 'no',
        pricing_cust_seg: getCustSegmentIds()
      },
      'gtmListingProductImpressions'
    );
  }

  if(segmentTrackingEnabled == 'ON'){
    let itemListName = '';
  let promotionArray = [];
  if (typeof ProductArray === 'object') {
    promotionArray =
      ProductArray.promotionArray || ProductArray.impressions || getStoreTypeArray || [];
  }
  if (promotionArray.length > 0) {
    itemListName = promotionArray[0].list || '';
  }
  let isDressTool = false;
  let dressToolSessionData;
  if (window?.location.search?.includes('dressTool')) {
    isDressTool = true;
    let tempDressToolSessionData = sessionStorage.getItem('dressToolIngressDetails') || {};
    if (tempDressToolSessionData) {
      dressToolSessionData = JSON.parse(tempDressToolSessionData);
    }
  }
  
  const previousSourceValue = window?.location.pathname?.includes('/search') || isVertexCategoryEnabled
    ? `|${previousSource}`
    : '';
    const newObjForSegment = {
      event: 'Product Viewed',
      // debug_lp: true,
      ...getTrendWidgetItmSourceProps(),
      screen_title: adsDataClickImp?.screen_title ? adsDataClickImp.screen_title : searchText,
      store_type: getStoreType(promotionArray?.map(el => el.dimension23)),
      impression_source: impression_source,
      impression_type : impression_type,
    // store_type: getStoreName(),
      previous_screen_name : previousSourceValue,
      // plp_source_details: isDressTool
      //   ? dressToolSessionData && dressToolSessionData?.BannerName
      //     ? dressToolSessionData?.BannerName
      //     : plp_source_details
      //   : plp_source_details,
      screen_source: isDressTool ? 'bra_dress tool' : isPLPSource,
      ...getParentProduct(parentProduct),
      //isGA4: true,
      ecommerce: {
        //item_list_name: sourcePage === 'fleek_curated_plp_screen' ? 'fleek_visit_ajiogram_store' : itemListName,
        items: promotionArray.map(product => {
          const productDiscount =          
            (product.wasProductPrice * getDiscountValueWithoutPercentage(product.dimension170)) 
              100 || 0;
              //console.log("product", product);
          return getProductItem(product, resolvedToken);
        })
      },
      //banner_theme_extended: showPlpExtendedBanner ? 'yes' : 'no',
      //pricing_cust_seg: getCustSegmentIds(),
      redirection_type: `${getPLPTypeOfRedirection(
        window?.location?.pathname || ''
      )} ${previousSourceValue}`,
      search_term: searchText || '',
      search_type : '',
      //user_search_term: searchText || '',
      //page_type: sourcePage,
      screen_name: sourcePage,
      ...(resolvedPageCategory && { page_category: resolvedPageCategory }),
      ...(bottomCardFilterValue?.length > 0 && { filters: bottomCardFilterValue })
    };
    // if (isDressTool) {
    //   newObjForSegment.dress_tool_ingress =
    //     dressToolSessionData && dressToolSessionData?.IngressPoint
    //       ? dressToolSessionData?.IngressPoint
    //       : '';
    // }

    //send to segment
    console.log("testing newObjForSegment", newObjForSegment);
    segmentDatalayerPushData(newObjForSegment, 'gtmListingProductImpressions');
  }

}

export function gtmFleekListingProductImpressions(
  ProductArray,
  storeName,
  page_name,
  page_type,
  dimension176,
  dimension177
) {
  const getStoreTypeArray =
    ProductArray?.length >= 0
      ? ProductArray
      : ProductArray?.impressions?.length >= 0
      ? ProductArray.impressions
      : [];

  const ga4AjioEnable = getGA4AJIOEnable(window?.__PRELOADED_STATE__?.flags);
  if (ga4AjioEnable) {
    let itemListName = '';
    let promotionArray = [];
    if (typeof ProductArray === 'object') {
      promotionArray =
        ProductArray.promotionArray || ProductArray.impressions || getStoreTypeArray || [];
    }
    if (promotionArray.length > 0) {
      itemListName = promotionArray[0].list || '';
    }
    gtmDatalayerPushData(
      {
        event: 'view_item_list',
        contains_store: getStoreName(),
        store_type: getStoreName(),
        isGA4: true,
        ecommerce: {
          item_list_name: itemListName,
          items: promotionArray.map(product => {
            const productDiscount =
              (product.price * getDiscountValueWithoutPercentage(product.dimension170)) / 100 || 0;
            return {
              item_id: product.id,
              item_name: product.name,
              discount: Number(productDiscount) || 0,
              index: Number(product.position) || 0,
              item_brand: product.brand,
              item_list_name: product.list || itemListName,
              item_category: product.category,
              item_variant: product.variant,
              price: Number(product.price) || 0,
              coupon: product.coupon,
              quantity: Number(product.quantity) || 1,
              product_id: product.dimension12,
              product_name: product.dimension13,
              product_category: product.dimension16,
              product_store_type: product.dimension23,
              product_segment: product.dimension36,
              product_portfolio: product.dimension37,
              product_vertical: product.dimension38,
              product_brick: product.dimension39,
              product_view_type: product.dimension41,
              ratings_shown_no_of_users: product.dimension46,
              available_quantity_deliverable_non_deliverable: product.dimension59,
              segment_id_experiment_id: product.dimension60,
              delivery_tag: product.dimension61,
              product_level_edd: product.dimension66,
              jio_ads_campaign_data: product.dimension161,
              prod_jio_ads_listing: product.dimension162,
              jio_ads_option_code: product.dimension163,
              sticker_name: product.dimension165,
              offer_name: product.dimension166,
              wishlish_count: product.dimension167,
              product_discount: product.dimension170,
              product_trade_discount: product.dimension171,
              product_size: product.dimension191
            };
          })
        },
        pricing_cust_seg: getCustSegmentIds(),
        page_name,
        page_type,
        post_id: dimension176,
        story_id: dimension177
      },
      'gtmListingProductImpressions'
    );

  } else {
    gtmDatalayerPushData(
      {
        event: 'ee_product_impressions',
        contains_store: getStoreType(getStoreTypeArray?.map(el => el.dimension23)),
        store_type: getStoreName(),
        ecommerce: {
          currencyCode: 'INR',
          impressions: ProductArray
        },
        pricing_cust_seg: getCustSegmentIds(),
        page_name,
        page_type,
        post_id: dimension176,
        story_id: dimension177
      },
      'gtmListingProductImpressions'
    );
  }

  if(segmentTrackingEnabled == 'ON'){
    let itemListName = '';
  let promotionArray = [];
  if (typeof ProductArray === 'object') {
    promotionArray =
      ProductArray.promotionArray || ProductArray.impressions || getStoreTypeArray || [];
  }
  if (promotionArray.length > 0) {
    itemListName = promotionArray[0].list || '';
  }
  const validToken = getValidAttributionToken();
  const resolvedPageCategory = getStoredPageCategory();
  
    //send to segment
    segmentDatalayerPushData(
      {
        event: 'Product Viewed',
        //debug_plp: true,
        //contains_store: getStoreType(promotionArray?.map(el => el.dimension23)),
        //store_type: getStoreName(),
        //isGA4: true,
        ...(resolvedPageCategory && { page_category: resolvedPageCategory }),
        ecommerce: {
        // item_list_name: itemListName,
          items: promotionArray.map(product => {
            const productDiscount =
              (product.price * getDiscountValueWithoutPercentage(product.dimension170)) / 100 || 0;
            return getProductItem(product, validToken);
          })
        },
        //pricing_cust_seg: getCustSegmentIds(),
        //page_name,
        //page_type,
        //post_id: dimension176,
        //story_id: dimension177
      },
      'gtmListingProductImpressions'
    );
  }


}

export function luxeGtmProductImpressions({
  impressions,
  list,
  store_type,
  page_name,
  page_type,
  contains_luxe,
  showPlpExtendedBanner,
  fromVideoBanner = false,
  video_name = '',
  video_load_time = 0,
  ProductArray = [],
  plp_source_details = false,
  plp_source = false,
  parentProduct,
  impression_source = '',
  impression_type = '',
  bottomCardFilterValue = [],
  pageCategory = ''
}) {
  const resolvedPageCategory = pageCategory || getStoredPageCategory();
  const validToken = getValidAttributionToken();
  const videoDetailsObject = {};
  if (fromVideoBanner) {
    (videoDetailsObject.video_name = video_name),
      (videoDetailsObject.video_load_time = video_load_time);
  }
  const getStoreTypeArray =
    ProductArray?.length >= 0
      ? ProductArray
      : ProductArray?.impressions?.length >= 0
      ? ProductArray.impressions
      : [];
  const ga4AjioEnable = getGA4AJIOEnable(window?.__PRELOADED_STATE__?.flags);
  if (ga4AjioEnable) {
    let itemListName = '';
    let promotionArray = [];
    if (typeof ProductArray === 'object') {
      promotionArray =
        ProductArray.promotionArray || ProductArray.impressions || getStoreTypeArray || [];
    }
    if (promotionArray.length > 0) {
      itemListName = promotionArray[0].list || '';
    }
    const userRelevancyFlag = getUserRelevancy(window?.__PRELOADED_STATE__?.flags);

    gtmDatalayerPushData(
      {
        event: 'view_item_list',
        event_category: 'enhance ecommerce',
        event_action: 'product impression',
        event_label: list,
        store_type: getStoreName(),
        plp_source_details,
        plp_source,
        contains_store: getStoreName(),
        isGA4: true,
        ecommerce: {
          item_list_name: itemListName,
          items: getStoreTypeArray.map(product => ({
            item_id: product.id,
            item_name: product.name,
            discount: Number(product.dimension12) || 0,
            index: Number(product.position) || 0,
            coupon: product.coupon,
            item_brand: product.brand,
            item_list_name: product.list || itemListName,
            item_category: product.category,
            item_variant: product.variant,
            price: Number(product.price) || 0,
            quantity: Number(product.quantity) || 1,
            product_id: product.dimension7,
            product_name: product.dimension6,
            product_category: product.dimension13,
            product_store_type: product.dimension23,
            product_brick: product.dimension14,
            product_tag: product.dimension15,
            product_color: product.dimension10,
            product_trade_discount: product.dimension12,
            product_price: product.dimension9,
            product_brand: product.dimension8,
            product_size: product.dimension11,
            Store_type: product.dimension16,
            segment_id_experiment_id: product.dimension60,
            offer_name: product.dimension82
          }))
        },
        page_type,
        page_name,
        contains_luxe,
        banner_theme_extended: showPlpExtendedBanner ? 'yes' : 'no',
        ...videoDetailsObject
      },
      'luxeGtmProductImpressions'
    );

  } else {
    gtmDatalayerPushData(
      {
        event: 'ee_product_impressions',
        event_category: 'enhance ecommerce',
        event_action: 'product impression',
        event_label: list,
        store_type: getStoreName(),
        plp_source_details,
        plp_source,
        contains_store: getStoreType(getStoreTypeArray.map(el => el.dimension23)),
        ecommerce: {
          currencyCode: 'INR',
          impressions
        },
        page_type,
        page_name,
        contains_luxe,
        banner_theme_extended: showPlpExtendedBanner ? 'yes' : 'no',
        ...videoDetailsObject
      },
      'luxeGtmProductImpressions'
    );
  }

  if(segmentTrackingEnabled == 'ON'){
    let itemListName = '';
  let promotionArray = [];
  if (typeof ProductArray === 'object') {
    promotionArray =
      ProductArray.promotionArray || ProductArray.impressions || getStoreTypeArray || [];
  }
  if (promotionArray.length > 0) {
    itemListName = promotionArray[0].list || '';
  }
  const userRelevancyFlag = getUserRelevancy(window?.__PRELOADED_STATE__?.flags);
    //push to segment
    segmentDatalayerPushData(
      {
        event: 'Product Viewed',
        //debug_lgp: true,
        event_category: 'enhance ecommerce',
        event_action: 'product impression',
        //event_label: list,
        //store_type: getStoreName(),
        //plp_source_details,
        screen_source : plp_source,
        //contains_store: getStoreType(promotionArray.map(el => el.dimension23)),
      // isGA4: true,
         ...getParentProduct(parentProduct),
        ecommerce: {
          item_list_name: itemListName,
          items: getStoreTypeArray.map(product => getProductItem(product, validToken))
        },
        screen_type: page_type,
        screen_name: page_name,
        impression_source,
        impression_type,
        ...(resolvedPageCategory && { page_category: resolvedPageCategory }),
        ...(bottomCardFilterValue?.length > 0 && {
          filters: bottomCardFilterValue
        })
        //contains_luxe,
        //banner_theme_extended: showPlpExtendedBanner ? 'yes' : 'no',
        //...videoDetailsObject
      },
      'luxeGtmProductImpressions'
    );
  }
}

export function gtmProductClick(id, name, price, brand, cat, variant, position, list) {
  gtmDatalayerPushData(
    {
      event: 'ee-productClicks',
      store_type: getStoreName(),
      contains_store: getStoreName(),
      ecommerce: {
        click: {
          actionField: { list },
          products: [
            {
              name,
              id,
              price,
              brand,
              category: cat,
              variant,
              position
            }
          ]
        }
      }
    },
    'gtmProductClick'
  );
}

export function luxeGtmProductClick({
  name,
  id,
  price,
  wasProductPrice,
  brand,
  position,
  category,
  product_size,
  product_color,
  product_trade_discount,
  product_brick,
  product_tag,
  list,
  impression_source = '',
  impression_type = '',
  store_type,
  pageType,
  pageName,
  sourceStore,
  containsLuxe,
  showPlpExtendedBanner,
  productTagEngineValue,
  productPriceLabel,
  video_name = '',
  video_load_time = 0,
  plpViewType,
  catalog,
  segmentId = '',
  experimentId = '',
  sourcePage = false,
  jioAdsSource = false,
  offerName = '',
  itmSourceDetailValue = '',
  skuId = ''
}) {
  const userRelevancyFlag = getUserRelevancy(window?.__PRELOADED_STATE__?.flags);
  const dimension60Data =
    Number(segmentId) || Number(experimentId) ? `${segmentId}|${experimentId}` : '';
  const ga4AjioEnable = getGA4AJIOEnable(window?.__PRELOADED_STATE__?.flags);
  let validToken = getValidAttributionToken();
  if (ga4AjioEnable) {
    const productDiscount =
      (wasProductPrice * getDiscountValueWithoutPercentage(product_trade_discount)) / 100 || 0;
    gtmDatalayerPushData(
      {
        event: 'select_item',
        event_category: 'enhance ecommerce',
        event_action: 'product click',
        event_label: list,
        store_type: getStoreName(),
        plp_source_details: jioAdsSource ? jioAdsSource.replaceAll('[ccb]', Date.now()) : false,
        plp_source: sourcePage || false,
        contains_store: catalogIdToStoreName(catalog),
        isGA4: true,
        ecommerce: {
          item_list_name: list,
          items: [
            {
              item_id: id,
              item_name: name,
              index: Number(position) || 0,
              item_brand: brand,
              item_list_name: list,
              item_category: category,
              price: Number(price) || 0,
              discount: Number(productDiscount) || 0,
              quantity: 1,
              coupon: '',
              product_name: name, // pass value for product_name
              product_id: id, // pass value for product_id
              product_size: product_size, // pass value for product_size
              product_trade_discount, // pass value for product_trade_discount
              product_category: category, // pass value for product_category
              product_brick: product_brick, // pass value for product_brick
              product_store_type: catalogIdToStoreName(catalog), // pass value for Store_type
              product_view_type: plpViewType, // pass value for pl view type: grid/list,
              segment_id_experiment_id: dimension60Data,
              sticker_name: productTagEngineValue || '', // product sticker name
              product_brand: brand, // pass value for product_brand
              product_price: price, // pass value for product_price
              product_color: isNaN(product_color) ? product_color : '', // pass value for product_color
              product_tag: product_tag, // pass value for product_tag
              Store_type: sourceStore,
              ...(validToken && {
                search_attribution: validToken
              }),
              ...(offerName ? { offer_name: offerName } : {}),
              ...(itmSourceDetailValue ? { plp_source_details: itmSourceDetailValue } : {})
            }
          ]
        },
        page_type: pageType,
        page_name: pageName,
        contains_luxe: containsLuxe,
        banner_theme_extended: showPlpExtendedBanner ? 'yes' : 'no',
        video_name,
        video_load_time
      },
      'luxeGtmProductClick'
    );

    

  } else {
    gtmDatalayerPushData(
      {
        event: 'ee_product_click',
        event_category: 'enhance ecommerce',
        event_action: 'product click',
        event_label: list,
        store_type: getStoreName(),
        plp_source_details: jioAdsSource ? jioAdsSource.replaceAll('[ccb]', Date.now()) : false,
        plp_source: sourcePage || false,
        contains_store: catalogIdToStoreName(catalog),
        ecommerce: {
          click: {
            actionField: { list },
            products: [
              {
                name,
                id,
                price,
                brand,
                category,
                position,
                dimension6: name, // pass value for product_name
                dimension7: id, // pass value for product_id
                dimension8: brand, // pass value for product_brand
                dimension9: price, // pass value for product_price
                dimension10: isNaN(product_color) ? product_color : '', // pass value for product_color
                dimension11: product_size, // pass value for product_size
                dimension12: product_trade_discount, // pass value for product_trade_discount
                dimension13: category, // pass value for product_category
                dimension14: product_brick, // pass value for product_brick
                dimension15: product_tag, // pass value for product_tag
                dimension16: sourceStore, // pass value for Store_type
                dimension23: catalogIdToStoreName(catalog),
                dimension41: plpViewType, // pass value for pl view type: grid/list,
                dimension60: dimension60Data,
                dimension89: productTagEngineValue || '', // product sticker name
                dimension90: productPriceLabel || '', // pass price label
                dimension91: '',
                ...(offerName
                  ? { [getStoreName() === 'luxe' ? 'dimension82' : 'dimension166']: offerName }
                  : {})
              }
            ]
          }
        },
        page_type: pageType,
        page_name: pageName,
        contains_luxe: containsLuxe,
        banner_theme_extended: showPlpExtendedBanner ? 'yes' : 'no',
        video_name,
        video_load_time
      },
      'luxeGtmProductClick'
    );
  }

  if(segmentTrackingEnabled == 'ON'){
    const productDiscount =
    (wasProductPrice * getDiscountValueWithoutPercentage(product_trade_discount)) / 100 || 0;
    //send to segment
    segmentDatalayerPushData(
      {
        event: 'Product Clicked',
        //event_category: 'enhance ecommerce',
        //event_action: 'product click',
        //event_label: list,
        screen_name : pageName,
        store_type: getStoreName(),
        //plp_source_details: jioAdsSource ? jioAdsSource.replaceAll('[ccb]', Date.now()) : false,
        screen_source: sourcePage || false,
        //contains_store: catalogIdToStoreName(catalog),
        //isGA4: true,
        //item_list_name: list,
        impression_source : impression_source || list,
        impression_type : impression_type || 'Horizontal',
        products: [
          {
            // item_id: id,
            // item_name: name,
            // index: Number(position) || 0,
            // item_brand: brand,
            // item_list_name: list,
            // item_category: category,
            // price: Number(price) || 0,
            // discount: Number(productDiscount) || 0,
            // quantity: 1,
            // coupon: '',
            product_name: name, // pass value for product_name
            // product_id: id + "_" + isNaN(product_color) ? product_color : '', // pass value for product_id
            product_id: id || '', // pass value for product_id
            //product_size: product_size, // pass value for product_size
            //product_trade_discount, // pass value for product_trade_discount
            product_mrp: wasProductPrice,
            product_category: category, // pass value for product_category
            product_brick: product_brick, // pass value for product_brick
            // product_store_type: userRelevancyFlag
            // ? catalogIdToStoreName(catalog) + '|' + productListType
            // : catalogIdToStoreName(catalog), // pass value for Store_type
            //product_view_type: plpViewType, // pass value for pl view type: grid/list,
            //segment_id_experiment_id: dimension60Data,
            //sticker_name: productTagEngineValue || '', // product sticker name
            product_brand: brand, // pass value for product_brand
            product_list_price: price, // pass value for product_price
            //product_color: isNaN(product_color) ? product_color : '', // pass value for product_color
            product_tag: product_tag, // pass value for product_tag
            //Store_type: sourceStore,
            product_segment: dimension60Data,
            catalog_id: catalog,
            ...(offerName ? { offer_name: offerName } : {}),
            ...(skuId ? { sku_id: skuId } : {})
            //...(userRelevancyFlag ? { product_store_type: getStoreName() + '|' + productListType } : {})
          }
        ],
        screen_type: pageType,
        screen_name: pageName,
        //contains_luxe: containsLuxe,
        //banner_theme_extended: showPlpExtendedBanner ? 'yes' : 'no',
        //video_name,
        //video_load_time,
        ...(validToken && {
          attribution_token: validToken
        })
      },
      'luxeGtmProductClick'
    );
  }

}

export function gtmGetMeta() {
  try {
    if (window) {
      let number = -1;
      window.dataLayer.forEach(function(elem, i) {
        if (elem.meta != undefined) {
          number = i;
        }
      });
      return number !== -1 && window.dataLayer[number].meta;
    }
    console.log('gtmGetProductsInCartFromMeta: window undefined');
  } catch (ex) {
    console.log(`gtmGetProductsInCartFromMeta - Exception: ${ex.message}`);
  }
}

export function gtmProceedToShipping(ProductArray, storeName, containsLuxe) {
  gtmDatalayerPushData(
    {
      event: 'ee_checkout',
      step: 1,
      store_type: getStoreName(),
      contains_luxe: containsLuxe,
      contains_store: getStoreType(ProductArray.map(el => el.dimension23)),
      ecommerce: {
        checkout: {
          actionField: { step: 1, option: 'shipping' },
          products: ProductArray
        }
      },
      pricing_cust_seg: readCookie('cohortSegment') || ''
    },
    'gtmProceedToShipping'
  );
}

export function gtmCartPage(
  ProductArray,
  storeName,
  containsLuxe,
  cart,
  isAssuredGifts,
  subscriptionDetails,
  pincode,
  isGSTSelected = false,
  membershipSavings ={},
  membershipInfo = {},
  bestCouponData = {},
  enableNonReturnableProductRevamp = false
) {
  //console.log("cart", cart);
  const ga4AjioEnable = getGA4AJIOEnable(window?.__PRELOADED_STATE__?.flags);
  let validToken = getValidAttributionToken();
  if (ga4AjioEnable) {
    if (!Array.isArray(ProductArray)) ProductArray = [];
    gtmDatalayerPushData(
      {
        event: 'begin_checkout',
        contains_store: getStoreType(ProductArray.map(el => el.dimension23)),
        step: 1,
        store_type: storeName,
        contains_luxe: containsLuxe,
        isGA4: true,
        event_category: 'Enhance E-commerce',
        event_action: 'begin_checkout',
        ...(subscriptionDetails && {
          subscription_details: subscriptionDetails
        }),
        ...(pincode && { pincode }),
        ecommerce: {
          currency: 'INR',
          value: ProductArray.reduce((acc, prod) => acc + (Number(prod.price) || 0), 0),
          items: ProductArray.map(product => ({
            item_id: product.id,
            item_name: product.name,
            discount: Number(product.discount) / (Number(product.quantity) || 1) || 0,
            index: Number(product.position) || 0,
            item_brand: product.brand,
            item_list_name: 'bag screen',
            item_category: product.category,
            item_variant: product.variant,
            price: Number(product.price) / (Number(product.quantity) || 1) || 0,
            quantity: Number(product.quantity) || 1,
            coupon: product.coupon,
            available_quantity_deliverable_non_deliverable: product.dimension59,
            segment_id_experiment_id: product.dimension60,
            delivery_tag: product.dimension61,
            product_level_edd: product.dimension66,
            product_store_type: product.dimension23,
            offer_name: containsLuxe ? product.dimension82 : product.dimension166,
            product_mrp: product?.product_mrp,
            ...(product.pincode && { pincode: product.pincode }),
            ...(product.priorityDeliveryFee && {
              product_priority_delivery_fee: Number(product.priorityDeliveryFee).toFixed(1)
            }),
            ...(product.sticker_name && { sticker_name: product.sticker_name }),
            ...(product.priorityDeliveryEDD && {
              priority_delivery_EDD: product.priorityDeliveryEDD
            }),
            ...(product.priority_delivery_sla_tag && {
              priority_delivery_sla_tag: product.priority_delivery_sla_tag
            }),
            ...(product.rushDeliveryFee && {
              product_rush_delivery_fee: Number(product.rushDeliveryFee).toFixed(1)
            }),
            ...(product.rushDeliveryEDD && {
              rush_delivery_EDD: product.rushDeliveryEDD
            }),
            ...(product.rush_delivery_sla_tag && {
              rush_delivery_sla_tag: product.rush_delivery_sla_tag
            }),
            ...(product?.ajioSuperCashCartEnable && (product.superCashData ?? {})),
            ...(product.search_attribution && {
              search_attribution: product.search_attribution
            }),
            ...(product.subscription_delivery_fee_saving && {
              subscription_delivery_fee_saving: product.subscription_delivery_fee_saving
            }),
            ...(product.subscription_platform_fee_saving && {
              subscription_platform_fee_saving: product.subscription_platform_fee_saving
            }),
            ...(product.subscription_total_savings && {
              subscription_total_savings: product.subscription_total_savings
            }),
            ...(product.subscription_membership_discount && {
              subscription_membership_discount: product.subscription_membership_discount
            }),
            ...(product.itm_source_detail && {
              itm_source_detail: product.itm_source_detail
            })
          }))
        },
        pricing_cust_seg: readCookie('cohortSegment') || ''
      },
      'cart'
    );
  } else {
    ProductArray.forEach(x => {
      delete x.discount;
      delete x.coupon;
      delete x.priorityDeliveryFee;
      delete x.priorityDeliveryEDD;
    });
    gtmDatalayerPushData(
      {
        event: 'ee_checkout',
        contains_store: getStoreType(ProductArray.map(el => el.dimension23)),
        step: 1,
        store_type: storeName,
        contains_luxe: containsLuxe,
        ecommerce: {
          checkout: {
            actionField: { step: 1, option: 'checkout' },
            products: ProductArray
          }
        },
        pricing_cust_seg: readCookie('cohortSegment') || ''
      },
      'cart'
    );
  }

  if(segmentTrackingEnabled == 'ON'){
    if (!Array.isArray(ProductArray)) ProductArray = [];
    // Send segment
    const enableGST = getGSTFlag(window?.__PRELOADED_STATE__);
    segmentDatalayerPushData(
      {
        event: 'Bag Details Viewed',
        store_type: getStoreType(ProductArray.map(el => el.dimension23)),
        bag_assured_gift_flag : isAssuredGifts?.cartAssuredGifts === 'ON',
        bag_price_update_callout : '',
        is_bag_merged: cart?.restoredProducts ? true : false,
        cart_id: cart?.id,
        ...(bestCouponData?.enabled && { coupon_applicability_flag: 'bag' }),
        ...(bestCouponData?.enabled && { gap_to_unlock: bestCouponData.gap_to_unlock ?? 0 }),
        ...(pincode && { pincode }),
        ...(enableGST && { is_gst_selected: isGSTSelected }),
        products: ProductArray.map(product => ({
          ...getProductItemForCart(product),
          ...(product.itm_source && { itm_source: product?.itm_source || '' }),
          ...(product.itm_source_detail && { itm_source_detail: product?.itm_source_detail || '' }),
          ...(product.product_cross_sell_type && { product_cross_sell_type: product.product_cross_sell_type }),
          ...(enableNonReturnableProductRevamp && {
            non_returnable_reason: getNonReturnableReason(product),
            non_exchangable_reason: getNonExchangableReason(product, isGSTSelected)
          }),
        })),
        ...membershipSavings,
        ...membershipInfo,
        subscription_first_purcase_date: 'NA',
        subscripiton_number: 'NA'
        //pricing_cust_seg: readCookie('cohortSegment') || ''
      },
      'cart'
    );
  }
}

export function gtmMassProceedToShipping(
  ProductArray,
  storeName,
  containsLuxe,
  cart,
  isAssuredGifts,
  ajioWalletData,
  cartItem,
  subscriptionDetails,
  pincode,
  isGSTSelected = false,
  membershipSavings = {},
  membershipInfo = {},
  enableNonReturnableProductRevamp = false
) {
  //console.log("gtmMassProceedToShipping cart", cart);
  //console.log("gtmMassProceedToShipping ProductArray", ProductArray);
  //console.log("gtmMassProceedToShipping ajioWalletData", ajioWalletData);

  const ga4AjioEnable = getGA4AJIOEnable(window?.__PRELOADED_STATE__?.flags);
  if (ga4AjioEnable) {
    const isStoreLuxe = storeName === 'luxe';
    if (!Array.isArray(ProductArray)) ProductArray = [];
    gtmDatalayerPushData(
      {
        event: 'add_shipping_info',
        step: 2,
        store_type: storeName,
        contains_store: getStoreType(ProductArray.map(el => el.dimension23)),
        contains_luxe: containsLuxe,
        isGA4: true,
        ...(subscriptionDetails && {
          subscription_details: subscriptionDetails
        }),
        ecommerce: {
          currency: 'INR',
          value: ProductArray.reduce((acc, prod) => acc + (Number(prod.price) || 0), 0),
          shipping_tier: '',
          items: ProductArray.map(product => ({
            item_id: product.id,
            item_name: product.name,
            discount: Number(product.discount) / (Number(product.quantity) || 1) || 0,
            index: Number(product.position) || 0,
            item_brand: product.brand,
            item_list_name: 'bag screen',
            item_category: product.category,
            item_variant: product.variant,
            price: Number(product.price) / (Number(product.quantity) || 1) || 0,
            quantity: Number(product.quantity) || 1,
            coupon: product.coupon,
            product_id: isStoreLuxe ? product.dimension7 : product.dimension12,
            product_name: isStoreLuxe ? product.dimension6 : product.dimension13,
            product_category: isStoreLuxe ? product.dimension13 : product.dimension16,
            product_store_type: product.dimension23,
            product_discount: product.dimension170,
            available_quantity_deliverable_non_deliverable: product.dimension59,
            segment_id_experiment_id: product.dimension60,
            delivery_tag: product.dimension61,
            product_level_edd: product.dimension66,
            offer_name: product.dimension166,
            ...(product.sticker_name && { sticker_name: product.sticker_name }),
            ...(isStoreLuxe && {
              Store_type: product.dimension16,
              product_tag: product.dimension15,
              product_color: product.dimension10,
              product_trade_discount: product.dimension12,
              product_price: product.dimension9,
              product_brand: product.dimension8,
              offer_name: product.dimension82
            }),
            ...(product.priorityDeliveryFee && {
              product_priority_delivery_fee: Number(product.priorityDeliveryFee).toFixed(1)
            }),
            ...(product.priorityDeliveryEDD && {
              priority_delivery_EDD: product.priorityDeliveryEDD
            }),
            ...(product.priority_delivery_sla_tag && {
              priority_delivery_sla_tag: product.priority_delivery_sla_tag
            }),
            ...(product.subscription_delivery_fee_saving && {
              subscription_delivery_fee_saving: product.subscription_delivery_fee_saving
            }),
            ...(product.subscription_platform_fee_saving && {
              subscription_platform_fee_saving: product.subscription_platform_fee_saving
            }),
            ...(product.subscription_total_savings && {
              subscription_total_savings: product.subscription_total_savings
            }),
            ...(product.subscription_membership_discount && {
              subscription_membership_discount: product.subscription_membership_discount
            })
          }))
        },
        pricing_cust_seg: readCookie('cohortSegment') || ''
      },
      'gtmProceedToShipping'
    );
  } else {
    ProductArray.forEach(x => {
      delete x.discount;
      delete x.coupon;
      delete x.priorityDeliveryFee;
      delete x.priorityDeliveryEDD;
    });
    gtmDatalayerPushData(
      {
        event: 'ee_checkout',
        step: 2,
        store_type: storeName,
        contains_store: getStoreType(ProductArray.map(el => el.dimension23)),
        contains_luxe: containsLuxe,
        ecommerce: {
          checkout_option: {
            actionField: { step: 2, option: 'checkout_option' },
            products: ProductArray
          }
        },
        pricing_cust_seg: readCookie('cohortSegment') || ''
      },
      'gtmProceedToShipping'
    );
  }

  if (segmentTrackingEnabled == 'ON') {
    if (!Array.isArray(ProductArray)) ProductArray = [];
    const enableGST = getGSTFlag(window?.__PRELOADED_STATE__);
    segmentDatalayerPushData(
      {
        event: 'Proceed to Payment Clicked',
        //step: 2,
        store_name: storeName,
        ...(pincode && { pincode }),
        ...membershipSavings,
        ...membershipInfo,
        subscription_first_purcase_date: 'NA',
        subscripiton_number: 'NA',
        store_type: getStoreType(ProductArray.map(el => el.dimension23)),
        ...getCartItemProperty(cart, isAssuredGifts, ajioWalletData),
        ...(enableGST && { is_gst_selected: isGSTSelected }),
        products: ProductArray?.map(product => ({
          ...getProductItemForCart(product),
          ...(product.itm_source && { itm_source: product.itm_source }),
          ...(product.itm_source_detail && { itm_source_detail: product.itm_source_detail }),
          ...(product.product_cross_sell_type && { product_cross_sell_type: product.product_cross_sell_type }),
          ...(enableNonReturnableProductRevamp && {
            non_returnable_reason: getNonReturnableReason(product),
            non_exchangable_reason: getNonExchangableReason(product, isGSTSelected)
          }),
        }))
        //pricing_cust_seg: readCookie('cohortSegment') || ''
      },
      'gtmProceedToShipping'
    );
  }
}

export function gtmPaymentClick(
  ProductArray,
  storeName,
  containsLuxe,
  cart,
  isAssuredGifts,
  ajioWalletData,
  cartItem,
  pincode,
  isGSTSelected = false,
  membershipSavings = {},
  membershipInfo = {}
) {
  const ga4AjioEnable = getGA4AJIOEnable(window?.__PRELOADED_STATE__?.flags);
  if (!ga4AjioEnable) {
    gtmDatalayerPushData(
      {
        event: 'ee_checkout',
        step: 3,
        store_type: storeName,
        contains_store: getStoreType(ProductArray.map(el => el.dimension23)),
        contains_luxe: containsLuxe,
        ecommerce: {
          checkout_option: {
            actionField: { step: 3, option: 'checkout_option' },
            products: ProductArray
          }
        },
        pricing_cust_seg: readCookie('cohortSegment') || ''
      },
      'gtmProceedToPayment'
    );
  }

  if (segmentTrackingEnabled == 'ON') {
    if (!Array.isArray(ProductArray)) ProductArray = [];
    const enableGST = getGSTFlag(window?.__PRELOADED_STATE__);
    segmentDatalayerPushData(
      {
        event: 'Payment Page Product Details',
        store_type: getStoreType(ProductArray.map(el => el.dimension23)),
        ...getCartItemProperty(cart, isAssuredGifts, ajioWalletData),
        ...(pincode && { delivery_pincode: pincode }),
        ...(enableGST && { is_gst_selected: isGSTSelected }),
        ...membershipSavings,
        ...membershipInfo,
        subscription_first_purcase_date: 'NA',
        subscripiton_number: 'NA',
        previous_screen_name: 'Bag Screen',
        screen_name: 'single page checkout',
        products: ProductArray?.map(product => ({
          ...getProductItemForCart(product)
        }))
      },
      'gtmProceedToPayment'
    );
  }
}

export function gtmProceedToPayment(ProductArray) {
  gtmDatalayerPushData(
    {
      event: 'ee_checkout',
      store_type: getStoreName(),
      contains_store: getStoreType(ProductArray.map(el => el.dimension23)),
      step: 2,
      ecommerce: {
        checkout: {
          actionField: { step: 2, option: 'payment' },
          products: ProductArray
        }
      }
    },
    'gtmProceedToPayment'
  );
}

export function getThePLPType() {
  try {
    if (window) {
      return window.location.href.includes('/search')
        ? 'search listing page'
        : window.location.href.includes('/c')
        ? 'category listing page'
        : window.location.href.includes('/b')
        ? 'brand listing page'
        : 'product listing page';
    }
    console.log('getThePLPType: window undefined');
  } catch (error) {
    console.log(`getThePLPType - Exception: ${ex.message}`);
  }
}

export function gtmAddToCart(
  id,
  name,
  price,
  brand,
  cat,
  variant,
  qty,
  discount,
  size,
  storeName = '',
  eventLabel = '',
  productData = '',
  productTagEngineValue = '',
  productPriceLabel = '',
  averageRating = 0,
  numUserRatings = '',
  catalogName = '',
  segmentId = '',
  experimentId = '',
  screenName = '',
  originalPrice,
  discountPrice,
  priorityDeliveryEDD,
  priorityDeliveryFee,
  vertexUniqueKey = '',
  copilotSource,
  pdRushData={},
  membershipMasterFlag,
  subscription_delivery_fee_saving,
  subscription_platform_fee_saving,
  subscription_total_savings,
  subscription_membership_discount,
  subscription_status,
  subscription_version,
  subscription_id,
  subscription_start_date,
  subscription_end_date,
  subscribed_orders_left,
  total_account_savings,
  platform_account_savings,
  delivery_account_savings,
  membership_discount_account_savings,
  subscription_first_purcase_date,
  subscripiton_number,
  is_subscription,
  brickCode = '',
  returnWindow = 0,
  isNonReturnable = false,
  enableNonReturnableProductRevamp = false,
  crossSellSource = false
) {

  const token = getValidAttributionToken();
  try {
    if (token && vertexUniqueKey) {
      const existingMap = JSON.parse(localStorage.getItem('cartAttributionMap') || '{}');
      existingMap[vertexUniqueKey] = token;
      localStorage.setItem('cartAttributionMap', JSON.stringify(existingMap));
    } else {
      localStorage.removeItem('cartAttributionMap');
    }
  } catch {
    localStorage.removeItem('cartAttributionMap');
  }

  const plaItem = getPlaItemByCode(brickCode);

  trackCopilotMap(vertexUniqueKey,copilotSource);

  storage.addItem(ENUM.STORETYPES, catalogIdToStoreName(catalogName));
  const dimension60Data =
    Number(segmentId) || Number(experimentId) ? `${segmentId}|${experimentId}` : '';
  const ga4AjioEnable = getGA4AJIOEnable(window?.__PRELOADED_STATE__?.flags);
  if (ga4AjioEnable) {
    const productDiscount =
      (Number(originalPrice) * getDiscountValueWithoutPercentage(discount)) / 100 || 0;
    const { pageName } = getPageInfo(
      window.location.pathname || '',
      false,
      storeName.toLowerCase() === FLEEK_STORE.toLowerCase()
    );
    gtmDatalayerPushData(
      {
        event: 'add_to_cart',
        event_label: eventLabel,
        event_category: 'enhance ecommerce',
        event_action: 'add to cart',
        contains_store: catalogIdToStoreName(catalogName),
        store_type: getStoreName(),
        isGA4: true,
        ecommerce: {
          currency: 'INR',
          value: Number(discountPrice) || 0,
          items: [
            {
              item_id: id,
              item_name: name,
              discount: Number(productDiscount) || 0,
              index: 0,
              item_brand: brand,
              item_list_name: screenName || pageName,
              item_category: cat,
              item_variant: variant,
              price: Number(discountPrice) || 0,
              coupon: '',
              quantity: Number(qty) || 1,
              product_id: id,
              product_name: name,
              product_size: getSkuAutoSelectSizeData(size),
              product_category: cat,
              product_store_type: catalogIdToStoreName(catalogName),
              segment_id_experiment_id: dimension60Data,
              jio_ads_option_code: productData,
              sticker_name: productTagEngineValue,
              offer_name: productPriceLabel,
              product_discount: getDiscountValue(discount),
              ...(token && {
                search_attribution: token
              }),
              ...(averageRating && {
                ratings_shown_no_of_users: `${averageRating}|${numUserRatings}`
              }),
              ...(priorityDeliveryFee && {
                product_priority_delivery_fee: Number(priorityDeliveryFee).toFixed(1)
              }),
              ...(priorityDeliveryEDD && { priority_delivery_EDD: priorityDeliveryEDD }),
              ...(copilotSource && { itm_source_detail : 'ai_assistant_widget'})
            }
          ]
        },
        pricing_cust_seg: getCustSegmentIds()
      },
      'ee_add_to_cart'
    );
   
  } else {
    gtmDatalayerPushData(
      {
        event: 'ee_add_to_cart',
        event_label: eventLabel,
        event_category: 'enhance ecommerce',
        event_action: 'add to cart',
        contains_store: catalogIdToStoreName(catalogName),
        store_type: getStoreName(),
        ecommerce: {
          currency: 'INR',
          add: {
            products: [
              {
                name,
                id,
                price,
                brand,
                category: cat,
                variant,
                quantity: qty,
                storeName,
                dimension12: id,
                dimension13: name,
                dimension14: '',
                dimension15: cat,
                dimension16: cat,
                dimension20: '',
                dimension21: brand,
                dimension22: price,
                dimension23: catalogIdToStoreName(catalogName),
                dimension24: size,
                dimension60: dimension60Data,
                dimension163: productData,
                dimension165: productTagEngineValue,
                dimension166: productPriceLabel,
                dimension170: getDiscountValue(discount),
                ...(averageRating && { dimension46: `${averageRating}|${numUserRatings}` })
              }
            ]
          }
        },
        pricing_cust_seg: getCustSegmentIds()
      },
      'ee_add_to_cart'
    );
  }

  if(segmentTrackingEnabled == 'ON'){
    const productDiscount =
    (Number(originalPrice) * getDiscountValueWithoutPercentage(discount)) / 100 || 0;
  const { pageName } = getPageInfo(
    window.location.pathname || '',
    false,
    storeName.toLowerCase() === FLEEK_STORE.toLowerCase()
  );
  let {pincode , ...restPdRushData} = pdRushData;
    const osmosConfigClientId = getPlaAdsClientID(window?.__PRELOADED_STATE__);
    segmentDatalayerPushData(
      {
        event: 'Add To Bag Clicked',
        event_label: eventLabel,
        event_category: 'enhance ecommerce',
        event_action: 'add to cart',
        //contains_store: catalogIdToStoreName(catalogName),
        //store_type: getStoreName(),
        //isGA4: true,
        add_to_bag_source : screenName || pageName,
        screen_name : screenName,
        screen_source: eventLabel,
        pincode: pincode && pincode,
        //currency: 'INR',
        //value: Number(discountPrice) || 0,
        ...(membershipMasterFlag && {
          subscription_delivery_fee_saving,
          subscription_platform_fee_saving,
          subscription_total_savings,
          subscription_membership_discount,
          subscription_status,
          subscription_version,
          subscription_id,
          subscripiton_number,
          subscription_start_date,
          subscription_end_date,
          subscribed_orders_left,
          total_account_savings,
          platform_account_savings,
          delivery_account_savings,
          membership_discount_account_savings,
          subscription_first_purcase_date,
        }),
        products: [
          {              
            // product_id: id,
            // product_name: name,
            // discount: Number(productDiscount) || 0,
            product_position: 0,
            product_brand: brand,
            // item_list_name: screenName || pageName,
            // item_category: cat,
            // item_variant: variant,
            product_mrp : originalPrice,
            product_list_price: Number(price) || 0,   
            product_offer_price : discountPrice,         
            // coupon: '',
            // quantity: Number(qty) || 1,
            product_id: id + "_" + variant,
            product_name: name,
            //product_size: getSkuAutoSelectSizeData(size),
            product_brick: cat,
            size_of_product: getSkuAutoSelectSizeData(size),
            size_added_flag: sessionStorage.getItem('defaultSKUSizeSelection') ? true : false,
            product_rating: averageRating,
            ...(copilotSource && { itm_source_detail : 'ai_assistant_widget'}),
            ...(crossSellSource && {
              itm_source_detail:
                new URLSearchParams(window.location.search).get('itm_source_detail') || '',
              itm_source: 'widget'
            }),
            product_tag: productTagEngineValue,
            ...restPdRushData,
            //product_store_type: catalogIdToStoreName(catalogName),
            //segment_id_experiment_id: dimension60Data,
            //jio_ads_option_code: productData,
            //sticker_name: productTagEngineValue,
            //offer_name: productPriceLabel,
            // product_discount: getDiscountValue(discount),
            // ...(averageRating && {
            //   ratings_shown_no_of_users: `${averageRating}|${numUserRatings}`
            // }),
            // ...(priorityDeliveryFee && {
            //   product_priority_delivery_fee: Number(priorityDeliveryFee).toFixed(1)
            // }),
            // ...(priorityDeliveryEDD && { priority_delivery_EDD: priorityDeliveryEDD }),
            ...(membershipMasterFlag && {
              is_subscription
            }),
            product_return_window: returnWindow ?? 0,
            product_exchange_window: returnWindow ?? 0,
            ...(enableNonReturnableProductRevamp && {
              atb_non_returnable_visible: isNonReturnable ? 'yes' : 'no'
            }),
            ...((vertexUniqueKey || plaItem?.code) && {
              sku_id: vertexUniqueKey || plaItem?.productCode
            }),
            ...(plaItem?.code && {
              seller_id: plaItem?.seller_id,
              client_id: plaItem?.client_id || osmosConfigClientId || ''})
          }
        ],
        ...(token && {
          attribution_token: token
        })
        //pricing_cust_seg: getCustSegmentIds()
      },
      'ee_add_to_cart'
    );
  }
}

export function gtmProductReturn(
  id,
  name,
  price,
  brand,
  cat,
  variant,
  qty,
  discount,
  size,
  storeName = ''
) {
  gtmDatalayerPushData(
    {
      event: 'purchase_refund',
      store_type: getStoreName(),
      contains_store: getStoreName(),
      action: 'Return',
      label: 'returnordersuccessful',
      ecommerce: {
        currency: 'INR',
        add: {
          products: [
            {
              name,
              id,
              price,
              brand,
              category: cat,
              variant,
              quantity: qty,
              storeName,
              dimension12: id,
              dimension13: name,
              dimension14: '',
              dimension15: cat,
              dimension16: cat,
              dimension20: '',
              dimension21: brand,
              dimension22: price,
              dimension23: getStoreName(),
              dimension24: size,
              dimension60: getCustSegmentIds(),
              dimension170: getDiscountValue(discount)
            }
          ]
        }
      },
      pricing_cust_seg: getCustSegmentIds()
    },
    'purchase_refund'
  );
}
export function luxeGtmAddToCart(
  name,
  id,
  price,
  brand,
  category,
  product_size,
  product_color,
  product_trade_discount,
  product_brick,
  product_tag,
  qty,
  list,
  store_type,
  pageType,
  pageName,
  eventLabel,
  sourceStore,
  containsLuxe,
  catalog,
  segmentId,
  experimentId,
  originalPrice,
  variant,
  productPriceLabel = '',
  priorityDeliveryEDD,
  priorityDeliveryFee,
  vertexUniqueKey,
  copilotSource,
  productData,
  membershipMasterFlag,
  subscription_delivery_fee_saving,
  subscription_platform_fee_saving,
  subscription_total_savings,
  subscription_membership_discount,
  subscription_status,
  subscription_version,
  subscription_id,
  subscription_start_date,
  subscription_end_date,
  subscribed_orders_left,
  total_account_savings,
  platform_account_savings,
  delivery_account_savings,
  membership_discount_account_savings,
  subscription_first_purcase_date,
  subscripiton_number,
  is_subscription,
  brickCode='',
  adsData = {},
  returnWindow = 0,
  isNonReturnable = false,
  enableNonReturnableProductRevamp = false,
  crossSellSource = false
) {

  trackCopilotMap(vertexUniqueKey,copilotSource);  
   const token = getValidAttributionToken();
  const dimension60Data =
    Number(segmentId) || Number(experimentId) ? `${segmentId}|${experimentId}` : '';
  const ga4AjioEnable = getGA4AJIOEnable(window?.__PRELOADED_STATE__?.flags);
  if (ga4AjioEnable) {
    const productDiscount =
      (Number(displayValueWithoutSymbol(originalPrice)) *
        getDiscountValueWithoutPercentage(product_trade_discount)) /
        100 || 0;
    gtmDatalayerPushData(
      {
        event: 'add_to_cart',
        store_type: getStoreName(),
        contains_store: getStoreName(),
        event_category: 'enhance ecommerce',
        event_action: 'add to cart',
        event_label: eventLabel,
        isGA4: true,
        ecommerce: {
          currency: 'INR',
          value: Number(price) || 0,
          items: [
            {
              item_id: id,
              item_name: name,
              discount: Number(productDiscount),
              index: 0,
              item_brand: brand,
              item_list_name: list,
              item_category: category,
              item_variant: variant,
              price: Number(price) || 0,
              coupon: '',
              quantity: Number(qty) || 1,
              product_name: name, // pass value for product_name
              product_id: id, // pass value for product_id
              product_size: getSkuAutoSelectSizeData(product_size), // pass value for product_size
              product_trade_discount, // pass value for product_trade_discount
              product_category: category, // pass value for product_category
              product_brick: product_brick, // pass value for product_brick
              product_store_type: sourceStore, // pass value for Store_type
              segment_id_experiment_id: dimension60Data,
              product_brand: brand, // pass value for product_brand
              product_price: price, // pass value for product_price
              product_color: isNaN(product_color) ? product_color : '', // pass value for product_color
              product_tag, // pass value for product_tag
              ...(productPriceLabel ? { offer_name: productPriceLabel } : {}),
              Store_type: sourceStore, // pass value for Store_type
              ...(priorityDeliveryFee && {
                product_priority_delivery_fee: Number(priorityDeliveryFee).toFixed(1)
              }),
              ...(priorityDeliveryEDD && { priority_delivery_EDD: priorityDeliveryEDD }),
              ...(copilotSource && { itm_source_detail : 'ai_assistant_widget'}),
              ...(crossSellSource && { product_cross_sell_type: 'cross_sell', itm_source_detail: 'cross_sell_widget' })
            }
          ]
        },
        page_type: pageType,
        page_name: pageName,
        contains_luxe: containsLuxe
      },
      'luxeGtmAddToCart'
    );

  } else {
    gtmDatalayerPushData(
      {
        event: 'ee_add_to_cart',
        store_type: getStoreName(),
        contains_store: getStoreName(),
        event_category: 'enhance ecommerce',
        event_action: 'add to cart',
        event_label: eventLabel,
        ecommerce: {
          add: {
            actionField: { list },
            products: [
              {
                name,
                id,
                price,
                brand,
                category,
                position: 1,
                quantity: qty,
                dimension6: name, // pass value for product_name
                dimension7: id, // pass value for product_id
                dimension8: brand, // pass value for product_brand
                dimension9: price, // pass value for product_price
                dimension10: isNaN(product_color) ? product_color : '', // pass value for product_color
                dimension11: product_size, // pass value for product_size
                dimension12: product_trade_discount, // pass value for product_trade_discount
                dimension13: category, // pass value for product_category
                dimension14: product_brick, // pass value for product_brick
                dimension15: product_tag, // pass value for product_tag
                dimension16: sourceStore, // pass value for Store_type
                dimension23: catalogIdToStoreName(catalog),
                dimension60: dimension60Data,
                ...(productPriceLabel ? { dimension82: productPriceLabel } : {})
              }
            ]
          }
        },
        page_type: pageType,
        page_name: pageName,
        contains_luxe: containsLuxe
      },
      'luxeGtmAddToCart'
    );
  }

  if(segmentTrackingEnabled == 'ON'){
    const productDiscount =
    (Number(displayValueWithoutSymbol(originalPrice)) *
      getDiscountValueWithoutPercentage(product_trade_discount)) /
      100 || 0;
    // sent to segment
    segmentDatalayerPushData(
      {
        event: 'Add To Bag Clicked',
        //store_type: getStoreName(),
        //contains_store: getStoreName(),
        event_category: 'enhance ecommerce',
        event_action: 'add to cart',
        source_screen: eventLabel,
        ...(crossSellSource && {
          itm_source: 'widget',
          itm_source_detail: new URLSearchParams(window.location.search).get('itm_source_detail') || ''
        }),
        //event_label: eventLabel,
        //isGA4: true,
        //currency: 'INR',
        //value: Number(price) || 0,
        ...(membershipMasterFlag && {
          subscription_delivery_fee_saving: subscription_delivery_fee_saving || "NA",
          subscription_platform_fee_saving: subscription_platform_fee_saving || "NA",
          subscription_total_savings: subscription_total_savings || "NA",
          subscription_membership_discount: subscription_membership_discount || "NA",
          subscription_status,
          subscription_version,
          subscription_id,
          subscripiton_number,
          subscription_start_date,
          subscription_end_date,
          subscribed_orders_left,
          total_account_savings,
          platform_account_savings,
          delivery_account_savings,
          membership_discount_account_savings,
          subscription_first_purcase_date,
        }),
        products: [
          {
            //product_id: id,
            //product_name: name,
          // discount: Number(productDiscount),
            product_position: 0,
            product_brand: brand,
          // item_list_name: list,
          // item_category: category,
          // item_variant: variant,
            product_mrp : originalPrice,
            product_list_price: Number(price) || 0,  
            //coupon: '',
            //quantity: Number(qty) || 1,
            product_name: name, // pass value for product_name
            product_id: id + "_" + variant, // pass value for product_id
            size_of_product: getSkuAutoSelectSizeData(product_size), // pass value for product_size
            size_added_flag: sessionStorage.getItem('defaultSKUSizeSelection') ? true : false,
            //product_trade_discount, // pass value for product_trade_discount
            //product_category: category, // pass value for product_category
            product_brick: product_brick, // pass value for product_brick
            //product_store_type: sourceStore, // pass value for Store_type
            product_segment: dimension60Data || "",
            product_vertical: category,
            //product_brand: brand, // pass value for product_brand
            //product_price: price, // pass value for product_price
            //product_color: isNaN(product_color) ? product_color : '', // pass value for product_color
            product_tag: product_tag, // pass value for product_tag
            //...(productPriceLabel ? { offer_name: productPriceLabel } : {}),
            //Store_type: sourceStore, // pass value for Store_type
            
            // ...(priorityDeliveryFee && {
            //   product_priority_delivery_fee: Number(priorityDeliveryFee).toFixed(1)
            // }),
            // ...(priorityDeliveryEDD && { priority_delivery_EDD: priorityDeliveryEDD }),
            ...(membershipMasterFlag && {
              is_subscription
            }),

            ...(Object.keys(adsData).length > 0 && {
              client_id: _get(product, 'adsData.cid', '') || osmosConfigClientId || ''
            }),
            ...(Object.keys(adsData).length > 0 && { seller_id: _get(product, 'sellerId', '') }),
            ...((Object.keys(adsData).length > 0 || vertexUniqueKey) && {
              sku_id: vertexUniqueKey || code
            }),
            product_return_window: returnWindow ?? 0,
            product_exchange_window: returnWindow ?? 0,
            ...(enableNonReturnableProductRevamp && {
              atb_non_returnable_visible: isNonReturnable ? 'yes' : 'no'
            })
          }
        ],
         ...(token && {
          attribution_token: token
        }),
        screen_type: pageType,
        screen_name: pageName
        //contains_luxe: containsLuxe
      },
      'luxeGtmAddToCart'
    );
  }
}

export function gtmRemoveFromCart(id, name, price, brand, cat, variant, qty) {
  gtmDatalayerPushData(
    {
      event: 'ee-removeFromCart',
      store_type: getStoreName(),
      contains_store: getStoreName(),
      ecommerce: {
        currency: 'INR',
        remove: {
          products: [
            {
              name,
              id,
              price,
              brand,
              category: cat,
              variant,
              quantity: qty
            }
          ]
        }
      }
    },
    'gtmRemoveFromCart'
  );
}

export function gtmProductDetailView(
  name,
  id,
  list,
  price,
  brand,
  cat,
  cat2,
  variant,
  tradeDiscount,
  size,
  productTag,
  priceLabel,
  averageRating,
  ratingCount,
  productCatalog,
  segmentId,
  experimentId,
  dimension59Data,
  discountPrice,
  earnRuleId,
  superCashEarning,
  validToken,
  itmSourceDetailValue = '',
  product_details_text,
  visual_format,
  product_offer_price
) {

  const dimension60Data =
    Number(segmentId) || Number(experimentId) ? `${segmentId}|${experimentId}` : '';
  gtmDatalayerPushData(
    {
      productName: name,
      productID: id,
      productPrice: price,
      productBrand: brand,
      productCategory: cat,
      productVariant: variant,
      productSubCategory: cat2,
      productDiscount: tradeDiscount,
      productSize: size,
      productQty: 1,
      store_type: getStoreName(),
      contains_store: catalogIdToStoreName(productCatalog)
    },
    'gtmProductDetailView'
  );

  const ga4AjioEnable = getGA4AJIOEnable(window?.__PRELOADED_STATE__?.flags);
  if (ga4AjioEnable) {
    const discount = (price * getDiscountValueWithoutPercentage(tradeDiscount)) / 100 || 0;
    gtmDatalayerPushData(
      {
        event: 'view_item',
        store_type: getStoreName(),
        contains_store: catalogIdToStoreName(productCatalog),
        pricing_cust_seg: getCustSegmentIds(),
        isGA4: true,
        event_category: 'Enhance E-commerce',
        event_action: 'view_item',
        ecommerce: {
          currency: 'INR',
          value: Number(discountPrice) || 0,
          items: [
            {
              item_id: id,
              item_name: name,
              discount: Number(discount) || 0,
              index: 0,
              item_brand: brand,
              item_list_name: list,
              item_category: cat,
              item_variant: variant,
              coupon: '',
              quantity: 1,
              price: Number(discountPrice) || 0,
              item_category2: cat2,
              product_id: id,
              product_name: name,
              product_category: cat2,
              product_store_type: catalogIdToStoreName(productCatalog),
              available_quantity_deliverable_non_deliverable: dimension59Data,
              segment_id_experiment_id: dimension60Data,
              sticker_name: productTag,
              offer_name: priceLabel,
              wishlish_count: '',
              ...(validToken && {
                search_attribution: validToken
              }),
              ...(earnRuleId && { earn_rule_id: earnRuleId }),
              ...(superCashEarning && { product_supercash_earn: superCashEarning }),
              product_discount: getDiscountValue(tradeDiscount),
              ...(averageRating && { ratings_shown_no_of_users: `${averageRating}|${ratingCount}` }),
              ...(itmSourceDetailValue ? { itm_source_detail: itmSourceDetailValue } : {})
            }
          ]
        }
      },
      'gtmProductDetailView'
    );
   
  } else {
    gtmDatalayerPushData(
      {
        event: 'ee_product_detail',
        store_type: getStoreName(),
        contains_store: catalogIdToStoreName(productCatalog),
        ecommerce: {
          currencyCode: 'INR',
          detail: {
            actionField: { list }, // 'detail' actions have an optional list property.
            products: [
              {
                name, // Name or ID is required.
                id,
                price,
                brand,
                category: cat,
                variant,
                size,
                category2: cat2,
                tradeDiscount,
                dimension12: id,
                dimension13: name,
                dimension14: '',
                dimension15: cat,
                dimension16: cat2,
                dimension20: '',
                dimension21: brand,
                dimension22: price,
                dimension23: catalogIdToStoreName(productCatalog),
                dimension24: '',
                dimension59: dimension59Data,
                dimension60: dimension60Data,
                dimension165: productTag,
                dimension166: priceLabel,
                dimension167: '',
                dimension170: getDiscountValue(tradeDiscount),
                ...(averageRating && { dimension46: `${averageRating}|${ratingCount}` })
              }
            ]
          }
        },
        pricing_cust_seg: getCustSegmentIds()
      },
      'gtmProductDetailView'
    );
  }

  if(segmentTrackingEnabled == 'ON'){
    const discount = (price * getDiscountValueWithoutPercentage(tradeDiscount)) / 100 || 0;
    segmentDatalayerPushData(
      {
        event: 'Product Details Viewed',
        //store_type: getStoreName(),
      // contains_store: catalogIdToStoreName(productCatalog),
      //  pricing_cust_seg: getCustSegmentIds(),
      // isGA4: true,
        screen_name: list,
        screen_source : list,
        ecommerce: {
          //currency: 'INR',
          //value: Number(discountPrice) || 0,
          items: [
            {
              // item_id: id,
              // item_name: name,
              // discount: Number(discount) || 0,
              product_position : 0,
              product_brand: brand,
              // item_list_name: list,
              // item_category: cat,
              // item_variant: variant,
              // coupon: '',
              // quantity: 1,
              product_list_price: Number(discountPrice) || 0,
              // item_category2: cat2,
              product_id: id + "_" + variant,
              product_name: name,
              product_brick: cat2,             
              
              product_segment: cat,
              product_details_text: product_details_text,
              product_offer_price: product_offer_price,
              product_mrp: price,
              visual_format: visual_format?.isBetterPdpEnabled ? 'Tabular' : 'Descriptor',
              ...(averageRating && { product_rating: `${averageRating}` }),
              ...(ratingCount && { number_of_ratings_collected : `${ratingCount}`}),
              product_tag: productTag
              // product_store_type: catalogIdToStoreName(productCatalog),
              // available_quantity_deliverable_non_deliverable: dimension59Data,
              // segment_id_experiment_id: dimension60Data,
              // sticker_name: productTag,
              // offer_name: priceLabel,
              // wishlish_count: '',
              // product_discount: getDiscountValue(tradeDiscount),
              // ...(averageRating && { ratings_shown_no_of_users: `${averageRating}|${ratingCount}` })
            }
          ]
        },
        ...(validToken && { attribution_token: validToken })
      },
      'gtmProductDetailView'
    );
  }
}

export function luxeGtmProductDetailView(
  name,
  id,
  price,
  brand,
  category,
  product_size,
  product_color,
  product_trade_discount,
  product_brick,
  product_tag,
  price_label,
  list,
  store_type,
  pageType,
  pageName,
  productCatalog,
  segmentId,
  experimentId,
  dimension59Data,
  originalPrice,
  offerName,
  itmSourceDetailValue = ''
) {
  const dimension60Data =
    Number(segmentId) || Number(experimentId) ? `${segmentId}|${experimentId}` : '';
  const ga4AjioEnable = getGA4AJIOEnable(window?.__PRELOADED_STATE__?.flags);
  if (ga4AjioEnable) {
    const discount =
      (originalPrice * getDiscountValueWithoutPercentage(product_trade_discount)) / 100 || 0;
    gtmDatalayerPushData(
      {
        event: 'view_item',
        store_type: getStoreName(),
        contains_store: catalogIdToStoreName(productCatalog),
        event_category: 'enhance ecommerce',
        event_action: 'details view',
        event_label: list,
        isGA4: true,
        ecommerce: {
          currency: 'INR',
          value: Number(price) || 0,
          items: [
            {
              item_id: id,
              item_name: name,
              discount: Number(discount) || 0,
              index: 0,
              item_brand: brand,
              item_list_name: list,
              item_category: category,
              price: Number(price) || 0,
              quantity: 1,
              product_name: name, // pass value for product_name
              product_id: id, // pass value for product_id
              product_size, // pass value for product_size
              product_category: category, // pass value for product_category
              product_brick, // pass value for product_brick
              product_store_type: catalogIdToStoreName(productCatalog), // pass value for Store_typ
              product_brand: brand, // pass value for product_brand
              product_price: price, // pass value for product_price
              product_color, // pass value for product_color
              product_trade_discount, // pass value for product_trade_discount
              product_tag, // pass value for product_tag
              Store_type: store_type, // pass value for Store_typ
              available_quantity_deliverable_non_deliverable: dimension59Data,
              segment_id_experiment_id: dimension60Data,
              ...(offerName ? { offer_name: offerName } : {}),
              ...(itmSourceDetailValue ? { itm_source_detail: itmSourceDetailValue } : {})
            }
          ]
        },
        page_type: pageType,
        page_name: pageName,
        contains_luxe: true
      },
      'luxeGtmProductDetailView'
    );
  } else {
    gtmDatalayerPushData(
      {
        event: 'ee_product_details',
        store_type: getStoreName(),
        contains_store: catalogIdToStoreName(productCatalog),
        event_category: 'enhance ecommerce',
        event_action: 'details view',
        event_label: list,
        ecommerce: {
          detail: {
            actionField: { list },
            products: [
              {
                name,
                id,
                price,
                brand,
                category,
                dimension6: name, // pass value for product_name
                dimension7: id, // pass value for product_id
                dimension8: brand, // pass value for product_brand
                dimension9: price, // pass value for product_price
                dimension10: product_color, // pass value for product_color
                dimension11: product_size, // pass value for product_size
                dimension12: product_trade_discount, // pass value for product_trade_discount
                dimension13: category, // pass value for product_category
                dimension14: product_brick, // pass value for product_brick
                dimension15: product_tag, // pass value for product_tag
                dimension16: store_type, // pass value for Store_typ
                dimension23: catalogIdToStoreName(productCatalog),
                dimension59: dimension59Data,
                dimension60: dimension60Data,
                dimension89: product_tag || '',
                dimension90: price_label || '',
                dimension91: '',
                ...(offerName ? { dimension82: offerName } : {})
              }
            ]
          }
        },
        page_type: pageType,
        page_name: pageName,
        contains_luxe: true
      },
      'luxeGtmProductDetailView'
    );
  }
}

export function gtmPurchaseComplete(
  tnxid,
  revenue,
  tax,
  shippingCharges,
  coupon,
  ProductArray,
  appliedCode,
  order,
  subscriptionDetails,
  pincode,
  membershipSavings = {},
  membershipInfo = {},
  urlPaymentMode = '',
  isBestCoupon = false,
  couponAppliedScreen = '',
  enableNonReturnableProductRevamp = false
) {
  const ga4AjioEnable = getGA4AJIOEnable(window?.__PRELOADED_STATE__?.flags);
  const validToken = getValidAttributionToken();
  if (ga4AjioEnable) {
    
    if (!Array.isArray(ProductArray)) ProductArray = [];
    gtmDatalayerPushData(
      {
        event: 'purchase',
        store_type: getStoreName(),
        contains_store: getStoreType(ProductArray.map(el => el.dimension23)),
        hybris_id: getUserUUID(),
        pricing_cust_seg: getCustSegmentIds(),
        event_category: 'Enhance E-commerce',
        event_action: 'purchase',
        isGA4: true,
        ...(pincode && { pincode }),
        ...(subscriptionDetails && {
          subscription_details: subscriptionDetails
        }),
        ecommerce: {
          transaction_id: tnxid,
          tax: Number(tax) || 0,
          shipping: Number(shippingCharges) || 0,
          currency: 'INR',
          coupon: appliedCode,
          value: ProductArray.reduce((acc, prod) => acc + (Number(prod.finalPrice) || 0), 0),
          items: ProductArray.map(product => ({
            item_id: product.id,
            item_name: product.name,
            discount: Number(product.discount) / (Number(product.quantity) || 1) || 0,
            index: Number(product.position) || 0,
            item_brand: product.brand,
            item_list_name: 'Thankyou',
            item_category: product.category,
            item_variant: product.variant,
            price: Number(product.finalPrice) / (Number(product.quantity) || 1) || 0,
            quantity: Number(product.quantity) || 1,
            coupon: appliedCode,
            product_id: product.dimension12,
            product_name: product.dimension13,
            product_category: product.dimension16,
            product_store_type: product.dimension23,
            product_segment: product.dimension36,
            product_portfolio: product.dimension37,
            product_vertical: product.dimension38,
            product_brick: product.dimension39,
            product_view_type: product.dimension41,
            ratings_shown_no_of_users: product.dimension46,
            available_quantity_deliverable_non_deliverable: product.dimension59,
            segment_id_experiment_id: product.dimension60,
            delivery_tag: product.dimension61,
            product_level_edd: product.dimension66,
            jio_ads_campaign_data: product.dimension161,
            prod_jio_ads_listing: product.dimension162,
            jio_ads_option_code: product.dimension163,
            sticker_name: product.dimension165,
            offer_name: product.dimension166,
            wishlish_count: product.dimension167,
            product_discount: product.dimension170,
            product_trade_discount: product.dimension171,
            product_size: product.dimension191,
            ...(product.pincode && { pincode: product.pincode }),
            ...(product.priorityDeliveryFee && {
              product_priority_delivery_fee: Number(product.priorityDeliveryFee).toFixed(1)
            }),
            ...(product.priorityDeliveryEDD && {
              priority_delivery_EDD: product.priorityDeliveryEDD
            }),
            ...(product.priority_delivery_sla_tag && {
              priority_delivery_sla_tag: product.priority_delivery_sla_tag
            }),
            ...(product.rushDeliveryFee && {
              product_rush_delivery_fee: Number(product.rushDeliveryFee).toFixed(1)
            }),
            ...(product.rushDeliveryEDD && {
              rush_delivery_EDD: product.rushDeliveryEDD
            }),
            ...(product.rush_delivery_sla_tag && {
              rush_delivery_sla_tag: product.rush_delivery_sla_tag
            }),
            ...(product.search_attribution && {
              search_attribution: product.search_attribution
            }),
            ...(product.subscription_delivery_fee_saving && {
              subscription_delivery_fee_saving: product.subscription_delivery_fee_saving
            }),
            ...(product.subscription_platform_fee_saving && {
              subscription_platform_fee_saving: product.subscription_platform_fee_saving
            }),
            ...(product.subscription_total_savings && {
              subscription_total_savings: product.subscription_total_savings
            }),
            ...(product.subscription_membership_discount && {
              subscription_membership_discount: product.subscription_membership_discount
            }),
            ...(product.itm_source_detail && {
              itm_source_detail: product.itm_source_detail
            }),
            ...(product.giftCount && {
              product_gift_with_purchase_flag: product.giftCount > 0
            })
          }))
        }
      },
      'gtmPurchaseComplete'
    );

  } else {
    ProductArray.forEach(x => {
      delete x.wasPrice;
      delete x.finalPrice;
      delete x.discount;
      delete x.priorityDeliveryFee;
      delete x.priorityDeliveryEDD;
    });
    gtmDatalayerPushData(
      {
        event: 'ee_purchase',
        store_type: getStoreName(),
        contains_store: getStoreType(ProductArray.map(el => el.dimension23)),
        hybris_id: getUserUUID(),
        pricing_cust_seg: getCustSegmentIds(),
        ecommerce: {
          purchase: {
            actionField: {
              id: tnxid,
              revenue,
              tax,
              shipping: shippingCharges,
              coupon
            },
            products: ProductArray
          }
        }
      },
      'gtmPurchaseComplete'
    );
  }

  if(segmentTrackingEnabled == 'ON'){
    if (!Array.isArray(ProductArray)) ProductArray = [];
    const enableGST = getGSTFlag(window?.__PRELOADED_STATE__, 'cart'); // TODO-GST check pagename for thankyou page
    let gstInfo = sessionStorage.getItem('gstInfo');
    let gstOrder = false;
    let cartItemGST = [];
    try {
      if (gstInfo) {
        gstInfo = JSON.parse(gstInfo);
        gstOrder = gstInfo?.gstDetails && Object.keys(gstInfo?.gstDetails).length > 0;
        cartItemGST = Array.isArray(gstInfo?.cartItemGST) ? gstInfo?.cartItemGST : [];
      }
    } catch (error) {
      console.error(error);
    }

    const isItemGSTEligible = skuId => {
      const gstItem = cartItemGST.find(x => x.code === skuId);
      if (gstItem) return gstItem?.isGstEligible || false;
      return false;
    };

    const productDataSeg = (order?.item || [])?.map(item => {
      const matchedEntry = order?.entries?.find(
        entry => entry?.product?.code === item?.code
      );

      return {
        ...item,
        deliveryMethod: matchedEntry?.deliveryMethod || null,
        deliverySLA: matchedEntry?.deliverySLA || null,
      };
    });

    const { noCostEmiDiscount = 0, cashbackAmount = 0 } = order?.emiOfferDetails || {};
    const emiOfferTypeParts = [
      noCostEmiDiscount > 0 && 'Instant Discount',
      cashbackAmount > 0 && 'Cashback'
    ].filter(Boolean);

    let selectedEmiPlan = {};
    try {
      const emiPlanData = readCookie('selectedEmiPlan');
      if (emiPlanData) {
        selectedEmiPlan = JSON.parse(decodeURIComponent(emiPlanData));
        const isLocalhost = location.hostname === 'localhost' || location.hostname === '127.0.0.1';
        const domainAttr = isLocalhost ? '' : '; domain=.services.ajio.com';
        document.cookie = `selectedEmiPlan=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/${domainAttr};`;
      }
    } catch (e) {}

    segmentDatalayerPushData(
      {
        event: 'Purchased',
        store_name: getStoreName(),
        // store_type: getStoreType(ProductArray.map(el => el.dimension23)),
        store_type: getCurrentStoreType(),
        order_id : order.id,
        order_total: revenue,
        bag_total:  order?.orderSummary?.bagTotal?.value,
       // bag_assured_gift_flag : isAssuredGifts?.cartAssuredGifts === 'ON',
        //bag_price_update_callout: '',
        bag_item_count : order?.totalItems,
        //is_bag_merged: cart?.restoredProducts ? true : false,
        bag_savings: order?.orderSummary?.bagDiscount?.value,
        coupon_savings: order?.orderSummary?.couponSaving?.value,
        order_total: order?.orderSummary?.orderTotal?.value,
        platform_fee: order?.orderSummary?.convenienceFee?.total?.netAmount?.value,
        total_savings: order?.orderSummary?.totalSaving?.value,
        rone_balance: order?.relianceOneEarnedAmount?.value,
        rone_balance_used:'',
        rone_points_applicable:'',
        //wallet_cash_balance: ajioWalletData?.ajioWalletBalanceDet?.totalWalletBalance?.totalCash,
        wallet_points_applicable:'',
        //wallet_points_balance: ajioWalletData?.ajioWalletBalanceDet?.totalWalletBalance?.totalPoints,
        wallet_points_used:'',
       // delivery_type_selected: cart?.deliveryInfo?.deliveryModeValue,
        delivery_fee:  order?.orderSummary?.deliveryCharge?.value,
        coupon_name: appliedCode,
        ...(couponAppliedScreen && { is_best_coupon: isBestCoupon ? 'yes' : 'no' }),
        ...(couponAppliedScreen && { coupon_applied_screen: couponAppliedScreen }),
        payment_type: order?.paymentCode,
        emi_type: selectedEmiPlan.emi_type || (noCostEmiDiscount > 0 ? 'No Cost' : ''),
        interest_rate: selectedEmiPlan.interest_rate !== undefined ? selectedEmiPlan.interest_rate : '',
        tenure_months: selectedEmiPlan.tenure_months || '',
        emi_amount: selectedEmiPlan.emi_amount || '',
        emi_processing_fees:
          selectedEmiPlan.emi_processing_fees !== undefined
            ? selectedEmiPlan.emi_processing_fees
            : '',
        emi_offer_type: selectedEmiPlan.emi_offer_type || emiOfferTypeParts.join(', '),
        bank_discount: order?.orderSummary?.bankDiscount?.value || 0,
        return_processing_fee: '',
        rone_balance_used:'',       
        upi_id_saved: '',
        wallet_points_used: '',
        // delivery_type_selected: '',
        delivery_edd:'',
        delivery_fee:  order?.orderSummary?.deliveryCharge?.value,
        ...membershipSavings,
        ...membershipInfo,
        subscription_first_purcase_date: 'NA',
        subscripiton_number: 'NA',
        ...(pincode && { pincode }),
        ...(enableGST && { is_gst_selected: gstOrder }),
        ecommerce: {
          //transaction_id: tnxid,
          //tax: Number(tax) || 0,
          shipping: Number(shippingCharges) || 0,
          currency: 'INR',
               
          items: (() => {
            let crossSellCodes = [];
            try {
              crossSellCodes = JSON.parse(sessionStorage.getItem('cross_sell_added_codes') || '[]');
            } catch {}
            const items = productDataSeg?.map(product => {
              const crossSellEntry = crossSellCodes.find(e => e.code === product.code);
              const crossSellWidgetTitle = getCrossSellWidgetSource(product?.code);
              return {
                ...getProductItemForCart(product, ProductArray, validToken),
                ...(enableGST && { is_gst_eligible: isItemGSTEligible(product.code) }),
                ...(enableNonReturnableProductRevamp && {
                  non_returnable_reason: product.isReturnable ? 'NA' : 'Product Policy',
                  non_exchangable_reason:
                    (!product.isExchangeable &&
                      (gstInfo?.gstDetails && Object.keys(gstInfo.gstDetails).length > 0
                        ? 'GST'
                        : 'Product Policy')) ||
                    'NA'
                }), 
                ...(crossSellWidgetTitle && {
                  itm_source: 'widget',
                  itm_source_detail: crossSellWidgetTitle
                }),
                ...(crossSellEntry && {
                  product_cross_sell_type: crossSellEntry.tabName || '',
                  itm_source: 'widget',
                  itm_source_detail: 'cross sell widget'
                })
              };
            });
            if (crossSellCodes.length) sessionStorage.removeItem('cross_sell_added_codes');
            return items;
          })()
        }
      },
      'gtmPurchaseComplete'
    );
  }

}

export function luxeGtmPurchaseComplete(
  tnxId,
  affiliation = '',
  revenue,
  tax,
  shipping,
  coupon,
  purchaseProduct = [],
  payment_mode,
  storeType,
  subscriptionDetails,
  pincode,
  membershipSavings = {},
  membershipInfo,
  enableNonReturnableProductRevamp = false,
  emiOfferDetails = {},
  paymentCode = ''
) {
  const ga4AjioEnable = getGA4AJIOEnable(window?.__PRELOADED_STATE__?.flags);
  const validToken = getValidAttributionToken();
  if (ga4AjioEnable) {
    gtmDatalayerPushData({
      event: 'purchase',
      hybris_id: getUserUUID(),
      event_category: 'enhance ecommerce',
      event_action: 'checkout-payment',
      event_label: payment_mode,
      store_type: storeType,
      contains_store: getStoreType(purchaseProduct.map(el => el.dimension23)),
      contains_luxe: true,
      isGA4: true,
      ...(pincode && { pincode }),
      ...(subscriptionDetails && {
        subscription_details: subscriptionDetails
      }),
      ecommerce: {
        transaction_id: tnxId,
        value: purchaseProduct.reduce((acc, prod) => acc + (Number(prod.finalPrice) || 0), 0),
        tax: Number(tax) || 0,
        shipping: Number(shipping) || 0,
        currency: 'INR',
        coupon,
        items: purchaseProduct.map(product => ({
          item_id: product.id,
          item_name: product.name,
          discount: Number(product.discount) / (Number(product.quantity) || 1) || 0,
          index: Number(product.position) || 0,
          item_brand: product.brand,
          item_list_name: 'Thankyou',
          item_category: product.category,
          item_variant: product.variant,
          price: Number(product.finalPrice) / (Number(product.quantity) || 1) || 0,
          coupon,
          quantity: Number(product.quantity) || 1,
          product_id: product.dimension7,
          product_name: product.dimension6,
          product_category: product.dimension13,
          product_store_type: product.dimension16,
          product_brick: product.dimension14,
          product_size: product.dimension11,
          Store_type: product.dimension16,
          product_tag: product.dimension15,
          product_color: product.dimension10,
          product_trade_discount: product.dimension12,
          product_price: product.dimension9,
          product_brand: product.dimension8,
          segment_id_experiment_id: product.dimension60,
          ...(product.pincode && { pincode: product.pincode }),
          ...(product.priorityDeliveryFee && {
            product_priority_delivery_fee: Number(product.priorityDeliveryFee).toFixed(1)
          }),
          ...(product.priorityDeliveryEDD && {
            priority_delivery_EDD: product.priorityDeliveryEDD
          }),
          ...(product.priority_delivery_sla_tag && {
            priority_delivery_sla_tag: product.priority_delivery_sla_tag
          }),
          ...(product.rushDeliveryFee && {
            product_rush_delivery_fee: Number(product.rushDeliveryFee).toFixed(1)
          }),
          ...(product.rushDeliveryEDD && {
            rush_delivery_EDD: product.rushDeliveryEDD
          }),
          ...(product.rush_delivery_sla_tag && {
            rush_delivery_sla_tag: product.rush_delivery_sla_tag
          }),
          ...(product.subscription_delivery_fee_saving && {
            subscription_delivery_fee_saving: product.subscription_delivery_fee_saving
          }),
          ...(product.subscription_platform_fee_saving && {
            subscription_platform_fee_saving: product.subscription_platform_fee_saving
          }),
          ...(product.subscription_total_savings && {
            subscription_total_savings: product.subscription_total_savings
          }),
          ...(product.subscription_membership_discount && {
            subscription_membership_discount: product.subscription_membership_discount
          }),
        }))
      }
    });

  } else {
    purchaseProduct.forEach(x => {
      delete x.wasPrice;
      delete x.finalPrice;
      delete x.discount;
      delete x.priorityDeliveryFee;
      delete x.priorityDeliveryEDD;
    });
    gtmDatalayerPushData({
      event: 'ee_purchase',
      hybris_id: getUserUUID(),
      event_category: 'enhance ecommerce',
      event_action: 'checkout-payment',
      event_label: payment_mode,
      store_type: storeType,
      contains_store: getStoreType(purchaseProduct.map(el => el.dimension23)),
      contains_luxe: true,
      ecommerce: {
        purchase: {
          actionField: {
            id: tnxId,
            affiliation,
            revenue,
            tax,
            shipping,
            coupon
          },
          products: purchaseProduct
        }
      }
    });
  }

  if(segmentTrackingEnabled == 'ON'){
    const enableGST = getGSTFlag(window?.__PRELOADED_STATE__, 'cart'); // TODO-GST check pagename for thankyou page
    let gstInfo = sessionStorage.getItem('gstInfo');
    let gstOrder = false;
    let cartItemGST = [];
    try {
      if (gstInfo) {
        gstInfo = JSON.parse(gstInfo);
        gstOrder = gstInfo?.gstDetails && Object.keys(gstInfo?.gstDetails).length > 0;
        cartItemGST = Array.isArray(gstInfo?.cartItemGST) ? gstInfo?.cartItemGST : [];
      }
    } catch (error) {
      console.error(error);
    }

    const isItemGSTEligible = skuId => {
      const gstItem = cartItemGST.find(x => x.code === skuId);
      if (gstItem) return gstItem?.isGstEligible || false;
      return false;
    };

    const { noCostEmiDiscount: luxeNoCostEmiDiscount = 0, cashbackAmount: luxeCashbackAmount = 0 } = emiOfferDetails || {};
    const luxeEmiOfferTypeParts = [
      luxeNoCostEmiDiscount > 0 && 'Instant Discount',
      luxeCashbackAmount > 0 && 'Cashback'
    ].filter(Boolean);

    let luxeSelectedEmiPlan = {};
    try {
      const emiPlanData = readCookie('selectedEmiPlan');
      if (emiPlanData) {
        luxeSelectedEmiPlan = JSON.parse(decodeURIComponent(emiPlanData));
        const isLocalhost = location.hostname === 'localhost' || location.hostname === '127.0.0.1';
        const domainAttr = isLocalhost ? '' : '; domain=.services.ajio.com';
        document.cookie = `selectedEmiPlan=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/${domainAttr};`;
      }
    } catch (e) {}

    segmentDatalayerPushData({
      event: 'Purchased',
      //hybris_id: getUserUUID(),
      event_category: 'enhance ecommerce',
      event_action: 'checkout-payment',
      event_label: payment_mode,
      store_type: storeType,
      //contains_store: getStoreType(purchaseProduct.map(el => el.dimension23)),
      //contains_luxe: true,
      //isGA4: true,
      order_id:tnxId,
      order_total: purchaseProduct.reduce((acc, prod) => acc + (Number(prod.finalPrice) || 0), 0),
      payment_type:
        payment_mode && paymentCode?.toLowerCase() !== 'cod'
          ? `${payment_mode} - ${paymentCode}`
          : paymentCode,
      emi_type: luxeSelectedEmiPlan.emi_type || (luxeNoCostEmiDiscount > 0 ? 'No Cost' : ''),
      interest_rate: luxeSelectedEmiPlan.interest_rate !== undefined ? luxeSelectedEmiPlan.interest_rate : '',
      tenure_months: luxeSelectedEmiPlan.tenure_months || '',
      emi_amount: luxeSelectedEmiPlan.emi_amount || '',
      emi_processing_fees: luxeSelectedEmiPlan.emi_processing_fees !== undefined ? luxeSelectedEmiPlan.emi_processing_fees : '',
      emi_offer_type: luxeSelectedEmiPlan.emi_offer_type || luxeEmiOfferTypeParts.join(', '),
      ...(pincode && { pincode }),
      ...(enableGST && { is_gst_selected: gstOrder }),
      ...membershipSavings,
      subscription_first_purcase_date: 'NA',
      subscripiton_number: 'NA',
      ...membershipInfo,
      ecommerce: {
        //transaction_id: tnxId,
        //value: purchaseProduct.reduce((acc, prod) => acc + (Number(prod.finalPrice) || 0), 0),
        //tax: Number(tax) || 0,
        //shipping: Number(shipping) || 0,
        //currency: 'INR',
        //coupon,
        items: (() => {
          let crossSellCodes = [];
          try {
            crossSellCodes = JSON.parse(sessionStorage.getItem('cross_sell_added_codes') || '[]');
          } catch {}
          const items = purchaseProduct.map(product => {
            const crossSellEntry = crossSellCodes.find(e => e.code === product.skuId);
             const crossSellWidgetTitle = getCrossSellWidgetSource(product?.code);
            return {
          product_id: product.id + "_" + product.variant,
          product_name: product.name,
          sku_id: product?.skuId,
          //discount: Number(product.discount) / (Number(product.quantity) || 1) || 0,
          product_position: Number(product.position) || 0,
          product_brand: product.brand,
          is_subscription: product?.isMembershipArticle,
          //item_list_name: 'Thankyou',
          //item_category: product.category,
          //item_variant: product.variant,
          product_list_price : Number(product?.price) / (Number(product.quantity) || 1) || 0,
          coupon_name: coupon,
          product_quantity: Number(product.quantity) || 1,
          // product_id: product.dimension7,
          // product_name: product.dimension6,
          // product_category: product.dimension13,
          // product_store_type: product.dimension16,
          product_brick: product.dimension14,
          product_size: product.dimension11,
          product_source_store: product.dimension16,
          product_tag: product.dimension15,
          product_gift_with_purchase_flag:
            Number(product?.giftQuantity ?? product?.giftCount ?? 0) > 0,
          //product_color: product.dimension10,
          //product_trade_discount: product.dimension12,
          //product_price: product.dimension9,
          //product_brand: product.dimension8,
          // segment_id_experiment_id: product.dimension60,
          // ...(product.priorityDeliveryFee && {
          //   product_priority_delivery_fee: Number(product.priorityDeliveryFee).toFixed(1)
          // }),
          // ...(product.priorityDeliveryEDD && {
          //   delivery_edd: product.priorityDeliveryEDD
          // }),
          // ...(product.priority_delivery_sla_tag && {
          //   priority_delivery_sla_tag: product.priority_delivery_sla_tag
          // })
          ...(product.pincode && { pincode: product.pincode }),
          ...(product.priorityDeliveryFee && {
            product_priority_delivery_fee: Number(product.priorityDeliveryFee).toFixed(1)
          }),
          ...(product.priorityDeliveryEDD && {
            priority_delivery_EDD: product.priorityDeliveryEDD
          }),
          ...(product.priority_delivery_sla_tag && {
            priority_delivery_sla_tag: product.priority_delivery_sla_tag
          }),
          ...(product.rushDeliveryFee && {
            product_rush_delivery_fee: Number(product.rushDeliveryFee).toFixed(1)
          }),
          ...(product.rushDeliveryEDD && {
            rush_delivery_EDD: product.rushDeliveryEDD
          }),
          ...(product.rush_delivery_sla_tag && {
            rush_delivery_sla_tag: product.rush_delivery_sla_tag
          }),
          ...(enableGST && {
            is_gst_eligible: isItemGSTEligible(product.skuId)
          }),
          product_return_window: product.returnWindow ?? 0,
          ...(enableNonReturnableProductRevamp && {
            non_returnable_reason: product.isReturnable ? 'NA' : 'Product Policy',
            non_exchangable_reason:
              (!product.isExchangeable &&
                (gstInfo?.gstDetails && Object.keys(gstInfo.gstDetails).length > 0
                  ? 'GST'
                  : 'Product Policy')) ||
              'NA'
          }),
         ...(crossSellWidgetTitle && {
                itm_source: 'widget',
                itm_source_detail: crossSellWidgetTitle
              }),
          ...(validToken && { attribution_token: validToken }),
              ...(crossSellEntry && {
                product_cross_sell_type: crossSellEntry.tabName || '',
                itm_source: 'widget',
                itm_source_detail: 'cross sell widget'
              })
            };
          });
          if (crossSellCodes.length) sessionStorage.removeItem('cross_sell_added_codes');
          return items;
        })()
      }
    });
  }

}

export function gtmPromotionImpressions(promotionArray = []) {
  const jioadsData = JSON.parse(localStorage.getItem('jioadsData'));
  const plpPageTitle = localStorage.getItem('plpPageTitle');
  const ga4AjioEnable = getGA4AJIOEnable(window?.__PRELOADED_STATE__?.flags);
  if (ga4AjioEnable) {
    gtmDatalayerPushData(
      {
        event: 'view_promotion',
        plp_page_title: plpPageTitle,
        hybris_id: getUserUUID(),
        isGA4: true,
        ecommerce: {
          items: promotionArray.map(promotion => ({
            creative_name: promotion.creative,
            creative_slot: promotion.position,
            promotion_id: promotion.id,
            promotion_name: promotion.name,
            ...(promotion.subscriptionDetails && {
              subscription_details: promotion.subscriptionDetails
            })
          }))
        }
      },
      'gtmPromotionImpressions'
    );  
    
  } else {
    gtmDatalayerPushData(
      {
        event: 'ee_Internal_Promotions_views',
        plp_page_title: plpPageTitle,
        hybris_id: getUserUUID(),
        ecommerce: {
          promoView: {
            promotions: promotionArray
          }
        }
      },
      'gtmPromotionImpressions'
    );
  }

   segmentEventPush({
      event:'Banner Viewed',
      ad_budget: '',
      ad_cost:'',
      ad_flag: jioadsData? true: false,
      ad_id: jioadsData?.id,
      ad_type:'',
      properties: {
        Banners: promotionArray.map(promotion => ({
          // creative_name: promotion.creative,
          banner_position: promotion.position || '',
          banner_id: promotion.id || '',
          banner_name: promotion.name || '',
          banner_type: promotion.type || 'IMAGE',
          clickable : promotion.clickable ?? true,
          ...(promotion?.uclid && { uclid: promotion?.uclid || "" }),
          client_id: promotion?.client_id || osmosConfigClientId || "",
          ...(promotion?.ad_source && { ad_source: promotion?.ad_source || "" }),
          ...(promotion?.sclid && { scl_id: promotion?.sclid || "" }),
          ...(promotion?.adsData && { ad_id: promotion?.adsData?.ad || "", ad_flag: true }),
        }))
      },   
      screen_name: plpPageTitle
    });


}

export function gtmPlpBannerView(promotionArray = []){
   const jioadsData = JSON.parse(localStorage.getItem('jioadsData'));
   const plpPageTitle = localStorage.getItem('plpPageTitle');
   const osmosConfigClientId = getPlaAdsClientID(window?.__PRELOADED_STATE__) || '';
   segmentEventPush({
    event:'Banner Viewed',
    ad_budget: '',
    ad_cost:'',
    ad_flag: jioadsData? true: false,
    ad_id: jioadsData?.id,
    ad_type:'',
    properties: {
      Banners: promotionArray.map(promotion => ({
        // creative_name: promotion.creative,
        banner_position: promotion.position || '',
        banner_id: promotion.id || '',
        banner_name: promotion.name || '',
        banner_type: promotion.type || 'IMAGE',
        clickable : promotion.clickable ?? true,
        ...(promotion?.uclid && { uclid: promotion?.uclid || "" }),
        client_id: promotion?.client_id || osmosConfigClientId || "",
        ...(promotion?.ad_source && { ad_source: promotion?.ad_source || "" }),
        ...(promotion?.sclid && { scl_id: promotion?.sclid || "" }),
        ...(promotion?.adsData && { ad_id: promotion?.adsData?.ad || "", ad_flag: true }),
      }))
    },
    screen_name: plpPageTitle
  });
}

export function gtmPromotionCmsImpressions(
  promotionArray = [],
  storeType = 'ajio',
  pageName = '',
  pageType = ''
) {
  const ga4AjioEnable = getGA4AJIOEnable(window?.__PRELOADED_STATE__?.flags);
  if (ga4AjioEnable) {
    gtmDatalayerPushData(
      {
        event: 'view_promotion',
        hybris_id: getUserUUID(),
        store_type: storeType,
        contains_store: getStoreName(),
        page_name: pageName,
        page_type: pageType,
        isGA4: true,
        ecommerce: {
          items: promotionArray.map(promotion => ({
            creative_name: promotion.creative,
            creative_slot: promotion.position,
            promotion_id: promotion.id,
            promotion_name: promotion.name,
            ...(promotion.subscriptionDetails && {
              subscription_details: promotion.subscriptionDetails
            })
          }))
        }
      },
      'gtmPromotionImpressions'
    );   
    
  } else {
    gtmDatalayerPushData(
      {
        event: 'ee_Internal_Promotions_views',
        hybris_id: getUserUUID(),
        store_type: storeType,
        contains_store: getStoreName(),
        page_name: pageName,
        page_type: pageType,
        ecommerce: {
          promoView: {
            promotions: promotionArray
          }
        }
      },
      'gtmPromotionCmsImpressions'
    );
  }
  let page = pageType;
  if(pageType.search("fleek") !== -1){
    page = pageType?.split("_")?.[0] || '';
  }
  const pageTypeOsmos = page === 'orderListing' ? 'orderList' : page === "thankyou" ? 'thankYou' : page === 'home screen' ? 'home' : page;
  const osmosConfig = getBannerOsmosAdsConfig(window?.__PRELOADED_STATE__) || '';
  const isOsmosEnable = pageTypeOsmos ? osmosConfig?.[pageTypeOsmos]?.isEnabled : '';
   segmentEventPush({
     event: 'Banner Viewed',
     ad_budget: '',
     ad_cost: '',
     ad_flag: isOsmosEnable,
     ad_id: '',
     ad_type: '',
     properties: {
       Banners: promotionArray.map(promotion => ({
         // creative_name: promotion.creative,
         banner_position: promotion.position || '',
         banner_id: promotion.id || '',
         banner_name: promotion.name || '',
         banner_type: promotion.type || 'IMAGE',
         clickable: promotion.clickable ?? true,
         ad_source: promotion.adSource || '',
         scl_id: promotion.sclid || '',
         uclid: promotion.uclid || '',
         client_id: promotion.clientId || ''
       }))
     },
     screen_name: pageName
   });

}

export function gtmPromotionPdpImpressions(
  promotionArray = [],
  storeType = 'ajio',
  productData,
  pageName = ''
) {
  const ga4AjioEnable = getGA4AJIOEnable(window?.__PRELOADED_STATE__?.flags);
  if (ga4AjioEnable) {
    gtmDatalayerPushData(
      {
        event: 'view_promotion',
        hybris_id: getUserUUID(),
        store_type: storeType,
        contains_store: getStoreName(),
        ...productData,
        page_name: pageName,
        isGA4: true,
        ecommerce: {
          items: promotionArray.map(promotion => ({
            creative_name: promotion.creative,
            creative_slot: promotion.position,
            promotion_id: promotion.id,
            promotion_name: promotion.name,
            ...(promotion.subscriptionDetails && {
              subscription_details: promotion.subscriptionDetails
            })
          }))
        }
      },
      'gtmPromotionImpressions'
    );   
   
  } else {
    gtmDatalayerPushData(
      {
        event: 'ee_Internal_Promotions_views',
        hybris_id: getUserUUID(),
        store_type: storeType,
        contains_store: getStoreName(),
        ...productData,
        page_name: pageName,
        ecommerce: {
          promoView: {
            promotions: promotionArray
          }
        }
      },
      'gtmPromotionCmsImpressions'
    );
  }

  segmentEventPush({
      event:'Banner Viewed',
      ad_budget: '',
      ad_cost:'',
      ad_flag: '',
      ad_id: '',
      ad_type:'',
      properties: {
        Banners: promotionArray.map(promotion => ({
          // creative_name: promotion.creative,
          banner_position: promotion.position || '',
          banner_id: promotion.id || '',
          banner_name: promotion.name || '',
          banner_type: promotion.type || 'IMAGE',
          clickable : promotion.clickable ?? true,
        }))
      },   
      screen_name: pageName
    });
}

export function gtmLuxePromotionImpressions(promotionArray = []) {
  const ga4AjioEnable = getGA4AJIOEnable(window?.__PRELOADED_STATE__?.flags);
  if (ga4AjioEnable) {
    gtmDatalayerPushData(
      {
        event: 'view_promotion',
        hybris_id: getUserUUID(),
        event_category: 'enhance ecommerce',
        event_action: 'banner impressions',
        store_type: 'luxe',
        contains_store: getStoreName(),
        isGA4: true,
        ecommerce: {
          items: promotionArray.map(promotion => ({
            creative_name: promotion.creative,
            creative_slot: promotion.position,
            promotion_id: promotion.id,
            promotion_name: promotion.name,
            ...(promotion.subscriptionDetails && {
              subscription_details: promotion.subscriptionDetails
            })
          }))
        }
      },
      'gtmPromotionImpressions'
    );
   
  } else {
    gtmDatalayerPushData(
      {
        event: 'ee_Internal_Promotions_views',
        hybris_id: getUserUUID(),
        event_category: 'enhance ecommerce',
        event_action: 'banner impressions',
        store_type: 'luxe',
        contains_store: getStoreName(),
        ecommerce: {
          promoView: {
            promotions: promotionArray
          }
        }
      },
      'gtmLuxePromotionImpressions'
    );
  }

  segmentEventPush({
      event:'Banner Viewed',
      ad_budget: '',
      ad_cost:'',
      ad_flag: '',
      ad_id: '',
      ad_type:'',
      properties: {
        Banners: promotionArray.map(promotion => ({
          // creative_name: promotion.creative,
          banner_position: promotion.position || '',
          banner_id: promotion.id || '',
          banner_name: promotion.name || '',
          banner_type: promotion.type || 'IMAGE',
          clickable : promotion.clickable ?? true,
        }))
      },      
      screen_name: pageName
    });
}

export function gtmLuxePromotionCmsImpressions(
  promotionArray = [],
  storeType = 'luxe',
  pageName = '',
  pageType = ''
) {
  const ga4AjioEnable = getGA4AJIOEnable(window?.__PRELOADED_STATE__?.flags);
  if (ga4AjioEnable) {
    if (!Array.isArray(promotionArray)) promotionArray = [];
    gtmDatalayerPushData(
      {
        event: 'view_promotion',
        hybris_id: getUserUUID(),
        store_type: storeType,
        contains_store: getStoreName(),
        page_name: pageName,
        page_type: pageType,
        isGA4: true,
        ecommerce: {
          items: promotionArray.map(promotion => ({
            creative_name: promotion.creative,
            creative_slot: promotion.position,
            promotion_id: promotion.id,
            promotion_name: promotion.name,
            ...(promotion.subscriptionDetails && {
              subscription_details: promotion.subscriptionDetails
            })
          }))
        }
      },
      'gtmPromotionImpressions'
    );    
   
  } else {
    gtmDatalayerPushData(
      {
        event: 'ee_Internal_Promotions_views',
        hybris_id: getUserUUID(),
        store_type: storeType,
        contains_store: getStoreName(),
        page_name: pageName,
        page_type: pageType,
        ecommerce: {
          promoView: {
            promotions: promotionArray
          }
        }
      },
      'gtmLuxePromotionCmsImpressions'
    );
  }

  const pageTypeOsmos = pageType === 'orderListing' ? 'orderList' : pageType === "thankyou" ? 'thankYou' : pageType === 'home screen' ? 'home' : pageType;
  const osmosConfig = getBannerOsmosAdsConfig(window?.__PRELOADED_STATE__) || '';
  const isOsmosEnable = pageType ? osmosConfig?.[pageTypeOsmos]?.isEnabled : '';

  segmentEventPush({
    event:'Banner Viewed',
    ad_budget: '',
    ad_cost:'',
    ad_flag: isOsmosEnable || '',
    ad_id: '',
    ad_type:'',
    properties: {
      Banners: promotionArray.map(promotion => ({
        // creative_name: promotion.creative,
        banner_position: promotion.position,
        banner_id: promotion.id,
        banner_name: promotion.name,
        banner_type: promotion.type || 'IMAGE',
        clickable : promotion.clickable ?? true,
        ad_source: promotion.adSource || '',
        scl_id: promotion.sclid || '',
        uclid: promotion.uclid || '',
        client_id: promotion.clientId || ''
      }))
    },    
    screen_name: pageName
  });
}

export function gtmPromotionClick(promoID, promoName, promoCreativeName, promoPosition, isJioAd = false, osmosSegmentPayload = {}, isOsmos = false) {
  const adsDataClickImp = JSON.parse(localStorage.getItem('adsDataClickImp'));
  const plpPageTitle = localStorage.getItem('plp_page_title');
  const ga4AjioEnable = getGA4AJIOEnable(window?.__PRELOADED_STATE__?.flags);
  if (ga4AjioEnable) {
    gtmDatalayerPushData(
      {
        event: 'select_promotion',
        ...(!isJioAd && {
          plp_page_title: adsDataClickImp?.plp_page_title || plpPageTitle
        }),
        hybris_id: getUserUUID(),
        store_type: getStoreName(),
        contains_store: getStoreName(),
        isGA4: true,
        ecommerce: {
          items: [
            {
              creative_name: promoCreativeName || '',
              ...(promoPosition && {
                creative_slot: promoPosition === undefined ? '' : promoPosition
              }),
              promotion_id: promoID || '',
              promotion_name: promoName || ''
            }
          ]
        }
      },
      'gtmPromotionClick'
    );   
  } else {
    gtmDatalayerPushData(
      {
        event: 'ee_Internal_Promotions_Clicks',
        plp_page_title: adsDataClickImp?.plp_page_title
          ? adsDataClickImp.plp_page_title
          : plpPageTitle,
        hybris_id: getUserUUID(),
        store_type: getStoreName(),
        contains_store: getStoreName(),
        ecommerce: {
          promoClick: {
            promotions: [
              {
                id: promoID || '',
                name: promoName || '',
                creative: promoCreativeName || '',
                position: promoPosition === undefined ? '' : promoPosition
              }
            ]
          }
        }
      },
      'gtmPromotionClick'
    );
  }

    segmentEventPush({
      event:'Banner Clicked',
      ad_budget: '',
      ad_cost:'',
      ad_flag: isJioAd || isOsmos || '',
      ad_id:'',
      ad_type:'',
      properties: {
        Banners: [
          {
            banner_id: promoID || '',
            banner_name : promoName || '',
            ...(promoPosition && {
                  banner_position: promoPosition === undefined ? '' : promoPosition
            }),      
            clickable : true,
            ...osmosSegmentPayload,
            banner_type : adsDataClickImp || 'IMAGE',
          }
        ]
      },
      screen_name: plpPageTitle
    });


}

export function gtmPlpBannerClick (promoID, promoName, promoCreativeName, promoPosition, isJioAd = false, uclid = '', client_id = '', ad_source = '', scl_id = ' ') {
  const adsDataClickImp = JSON.parse(localStorage.getItem('adsDataClickImp'));
  const plpPageTitle = localStorage.getItem('plp_page_title');
   segmentEventPush({
      event:'Banner Clicked',
      ad_budget: '',
      ad_cost:'',
      ad_flag: isJioAd,
      ad_id:'',
      ad_type:'',
      properties: {
        Banners: [
          {
            banner_id: promoID || '',
            banner_name : promoName || '',
            ...(promoPosition && {
                  banner_position: promoPosition === undefined ? '' : promoPosition
            }),      
            banner_type : adsDataClickImp || 'IMAGE',
            clickable : true,
            ...(ad_source && { ad_source: ad_source }) ,
            ...(client_id && { client_id: client_id }) ,
            ...(uclid && { uclid: uclid }),
            ...(scl_id && { scl_id: scl_id }),
          }
        ]
      },
      screen_name: plpPageTitle
    });
}

export function gtmPromotionCmsClick(
  promoID,
  promoName,
  promoCreativeName,
  promoPosition,
  storeType,
  pageName,
  pageType,
  isJioAds = 'false',
  cid = '',
  jioAdsBannerName = '',
  isPDBanner = 'false',
  subscriptionDetails = null,
  banner_type = '',
  sclid = '',
  uclid = '',
  client_id = ''
) {
  const ccb = UTILS.getCCB(jioAdsBannerName);
  const adSource = banner_type === 'EXTERNAL_AD' ? 'osmos' : isJioAds ? 'jioads' : 'no_ads';
  const ga4AjioEnable = getGA4AJIOEnable(window?.__PRELOADED_STATE__?.flags);
  if (ga4AjioEnable) {
    gtmDatalayerPushData(
      {
        event: 'select_promotion',
        hybris_id: getUserUUID(),
        store_type: storeType,
        contains_store: getStoreName(),
        page_name: pageName,
        page_type: pageType,
        isGA4: true,
        ...(subscriptionDetails && {
          subscription_details: subscriptionDetails
        }),
        ecommerce: {
          items: [
            {
              creative_name: promoCreativeName || '',
              ...(promoPosition && { creative_slot: promoPosition || '' }),
              ...((cid || promoID) && {
                promotion_id: isJioAds === 'true' ? cid.replace('[ccb]', ccb) : promoID || ''
              }),
              promotion_name:
                isJioAds === 'true'
                  ? `jioads - ${jioAdsBannerName}`
                  : isPDBanner === 'true'
                  ? `priority - ${promoName}`
                  : promoName || ''
            }
          ]
        }
      },
      'gtmPromotionCmsClick'
    );

  } else {
    gtmDatalayerPushData(
      {
        event: 'ee_Internal_Promotions_Clicks',
        hybris_id: getUserUUID(),
        store_type: storeType,
        contains_store: getStoreName(),
        page_name: pageName,
        page_type: pageType,
        ecommerce: {
          promoClick: {
            promotions: [
              {
                id: isJioAds === 'true' ? cid.replace('[ccb]', ccb) : promoID || '',
                name: isJioAds === 'true' ? `jioads - ${jioAdsBannerName}` : isPDBanner === 'true' ? `priority - ${promoName}` : promoName || '',
                creative: promoCreativeName || '',
                position: promoPosition || ''
              }
            ]
          }
        }
      },
      'gtmPromotionCmsClick'
    );
  }

   segmentEventPush({
      event:'Banner Clicked',
      ad_budget: '',
      ad_cost:'',
      ad_flag: isJioAds || banner_type === "EXTERNAL_AD" ? true : '',
      ad_id: cid,
      ad_type:'',
      properties: {
        Banners: [
          {
            banner_id: promoID || '',
            banner_name :  banner_type === "EXTERNAL_AD" ? `osmos - ${promoName}` :  isJioAds === 'true'
                        ? `jioads - ${jioAdsBannerName}`
                        : isPDBanner === 'true'
                        ? `priority - ${promoName}`
                        : promoName || '',
            ...(promoPosition && { banner_position: promoPosition || '' }),     
            banner_type : banner_type || 'IMAGE',
            clickable : true,
            scl_id: sclid || '',
            uclid: uclid || '',
            client_id: client_id || '',
            ad_source: adSource
          }
        ]
      },
      screen_name: pageName
    });
}

export function gtmLuxePromotionClick(
  promoID,
  promoName,
  promoCreativeName,
  promoPosition,
  storeType
) {
  const ga4AjioEnable = getGA4AJIOEnable(window?.__PRELOADED_STATE__?.flags);
  if (ga4AjioEnable) {
    gtmDatalayerPushData(
      {
        event: 'select_promotion',
        hybris_id: getUserUUID(),
        event_category: 'enhance ecommerce',
        event_action: 'banner click',
        store_type: storeType,
        contains_store: getStoreName(),
        isGA4: true,
        ecommerce: {
          items: [
            {
              creative_name: promoCreativeName || '',
              creative_slot: promoPosition || '',
              promotion_id: promoID || '',
              promotion_name: promoName || ''
            }
          ]
        }
      },
      'gtmLuxePromotionClick'
    );
    
  } else {
    gtmDatalayerPushData(
      {
        event: 'ee_Internal_Promotions_Clicks',
        hybris_id: getUserUUID(),
        event_category: 'enhance ecommerce',
        event_action: 'banner click',
        store_type: storeType,
        contains_store: getStoreName(),
        ecommerce: {
          promoClick: {
            promotions: [
              {
                id: promoID || '',
                name: promoName || '',
                creative: promoCreativeName || '',
                position: promoPosition || ''
              }
            ]
          }
        }
      },
      'gtmLuxePromotionClick'
    );
  }

  segmentEventPush({
      event:'Banner Clicked',
      ad_budget: '',
      ad_cost:'',
      ad_flag: '',
      ad_id: '',
      ad_type:'',
      properties: {
        Banners: [
          {
            banner_id: promoID || '',
            banner_name : promoName || '',
            ...(promoPosition && { banner_position: promoPosition || '' }),     
            banner_type : adsDataClickImp || 'IMAGE',
            clickable : true,
          }
        ]
      },
      screen_name: '',
    });
}

export function gtmLuxePromotionCmsClick(
  promoID,
  promoName,
  promoCreativeName,
  promoPosition,
  storeType,
  pageName,
  pageType,
  isJioAds = 'false',
  cid = '',
  jioAdsBannerName = '',
  subscriptionDetails,
  banner_type = '',
  sclid = '',
  uclid = '',
  client_id = ''
) {
  const ccb = UTILS.getCCB(jioAdsBannerName);
  const adSource = banner_type === 'EXTERNAL_AD' ? 'osmos' : isJioAds ? 'jioads' : 'no_ads';
  const ga4AjioEnable = getGA4AJIOEnable(window?.__PRELOADED_STATE__?.flags);
  if (ga4AjioEnable) {
    gtmDatalayerPushData(
      {
        event: 'select_promotion',
        hybris_id: getUserUUID(),
        store_type: storeType,
        contains_store: getStoreName(),
        page_name: pageName,
        page_type: pageType,
        isGA4: true,
        ...(subscriptionDetails && {
          subscription_details: subscriptionDetails
        }),
        ecommerce: {
          items: [
            {
              creative_name: promoCreativeName || '',
              ...(promoPosition && {
                creative_slot: promoPosition || ''
              }),
              ...((cid || promoID) && {
                promotion_id: isJioAds === 'true' ? cid.replace('[ccb]', ccb) : promoID || ''
              }),
              promotion_name:
                isJioAds === 'true' ? `jioads - ${jioAdsBannerName}` : promoName || ''
            }
          ]
        }
      },
      'gtmLuxePromotionCmsClick'
    );       
    
  } else {
    gtmDatalayerPushData(
      {
        event: 'ee_Internal_Promotions_Clicks',
        hybris_id: getUserUUID(),
        store_type: storeType,
        contains_store: getStoreName(),
        page_name: pageName,
        page_type: pageType,
        ecommerce: {
          promoClick: {
            promotions: [
              {
                id: isJioAds === 'true' ? cid.replace('[ccb]', ccb) : promoID || '',
                name: isJioAds === 'true' ? `jioads - ${jioAdsBannerName}` : promoName || '',
                creative: promoCreativeName || '',
                position: promoPosition || ''
              }
            ]
          }
        }
      },
      'gtmLuxePromotionCmsClick'
    );
  }

  segmentEventPush({
      event:'Banner Clicked',
      ad_budget: '',
      ad_cost:'',
      ad_flag: isJioAds || banner_type === 'EXTERNAL_AD' ? true : false,
      ad_id: cid,
      ad_type:'',
      properties: {
        Banners: [
          {
            banner_id: isJioAds === 'true' ? cid.replace('[ccb]', ccb) : promoID || '',
            banner_name : banner_type === 'EXTERNAL_AD' ? `osmos - ${promoName}` : isJioAds === 'true' ? `jioads - ${jioAdsBannerName}` : promoName || '',
            ...(promoPosition && { banner_position: promoPosition || '' }),     
            banner_type : banner_type || 'IMAGE',
            clickable : true,
            scl_id: sclid || '',
            uclid: uclid || '',
            client_id: client_id || '',
            ad_source: adSource
          }
        ]
      },
      screen_name: pageName
  });
}

export function gtmRefundEvent(id, products = {}, pageType = '', pageName = '') {
  gtmDatalayerPushData(
    {
      event: 'ee_return',
      store_type: getStoreName(),
      contains_store: getStoreName(),
      hybris_id: getUserUUID(),
      ecommerce: {
        refund: {
          actionField: { id },
          ...products
        }
      },
      page_type: pageType,
      page_name: pageName
    },
    'gtmRefundEvent'
  );
}

export function gtmGA4RefundEvent(id, product, pageType = '', pageName = '', returnId) {
  gtmDatalayerPushData(
    {
      event: 'refund',
      store_type: getStoreName(),
      contains_store: getStoreName(),
      hybris_id: getUserUUID(),
      isGA4: true,
      ecommerce: {
        transaction_id: id,
        order_status: 'DELIVERED',
        return_id: returnId,
        value: product.value * product.quantity,
        currency: 'INR',
        tax: Number(product.tax) || 0,
        shipping: Number(product.shipping) || 0,
        coupon: product.coupon,
        items: [
          {
            item_id: product.id,
            item_name: product.name,
            discount: product.discount,
            index: product.index,
            item_brand: product.brand,
            item_list_name: product.list,
            item_category: product.category,
            item_variant: product.variant,
            price: product.price,
            quantity: product.quantity || 1,
            segment_id_experiment_id: product.segmentId,
            ...(product.offer_name && { offer_name: product.offer_name })
          }
        ]
      },
      page_type: pageType,
      page_name: pageName
    },
    'gtmRefundEvent'
  );
}

export function gtmFeedPostClick(
  itemId,
  itemName,
  creativeName,
  creativeSlot,
  screenName = '',
  storeType = FLEEK_STORE.toLowerCase(),
  banner_type = ''
) {
  const ga4AjioEnable = getGA4AJIOEnable(window?.__PRELOADED_STATE__?.flags);
  if (ga4AjioEnable) {
    gtmDatalayerPushData(
      {
        event: 'select_promotion',
        hybris_id: getUserUUID(),
        store_type: storeType,
        contains_store: getStoreName(),
        page_name: screenName,
        isGA4: true,
        ecommerce: {
          items: [
            {
              creative_name: creativeName,
              creative_slot: creativeSlot,
              promotion_id: itemId,
              promotion_name: itemName
            }
          ]
        }
      },
      'gtmPromotionCmsClick'
    );

  } else {
    gtmDatalayerPushData(
      {
        event: 'ee_Internal_Promotions_Clicks',
        hybris_id: getUserUUID(),
        store_type: storeType,
        contains_store: getStoreName(),
        page_name: screenName,
        ecommerce: {
          promoClick: {
            promotions: [
              {
                id: itemId,
                name: itemName,
                creative: creativeName,
                position: creativeSlot
              }
            ]
          }
        }
      },
      'gtmPromotionCmsClick'
    );
  }

  segmentEventPush({
      event:'Banner Clicked',
      ad_budget: '',
      ad_cost:'',
      ad_flag: '',
      ad_id: '',
      ad_type:'',
      
      properties: {
        Banners:[
          {
            banner_id: itemId,
            banner_name : creativeName,
            ...(creativeSlot && { banner_position: creativeSlot || '' }),     
            banner_type : banner_type || 'IMAGE',
            clickable : true,
          }
        ]
      },
      screen_name: screenName
  });

}

export function gtmScratchCardEventPush(obj) {
  gtmDatalayerPushData(
    {
      ...obj
    },
    'gtmScratchCardEventPush'
  );
}

export function gtmTopShoppersEventPush(obj) {
  gtmDatalayerPushData(
    {
      ...obj
    },
    'gtmTopShoppersEventPush'
  );
}

export function gtmDynamicRemarketingSetup(prodIds, pageType, totalValue = 0) {
  const tagsParams = {
    ecomm_prodid: prodIds,
    ecomm_pagetype: pageType
  };
  if (pageType === 'cart') {
    tagsParams.ecomm_totalvalue = totalValue || 0;
  }
  gtmDatalayerPushData(
    {
      event: 'dynRmktParamsReady',
      google_tag_params: tagsParams
    },
    'gtmDynamicRemarketingSetup'
  );
}

export function gtmPrimeAICTA(gaType = null, displayValue = null) {
  console.log('🚀 ~ file: GTMdatalayer.js ~ line 803 ~ gtmPrimeAICTA ~ gaType', gaType);
  const gaParams = {
    event: 'find_recomonded_size',
    event_category: 'product detail interactions',
    event_action: 'find recommended size click'
  };
  if (gaType === 'EDIT') {
    gaParams.event = 'recomonded_size_click';
    gaParams.event_action = 'recommended size click';
  } else if (gaType === 'CONTINUE') {
    gaParams.event = 'continue_cta';
    gaParams.event_category = 'recommended size interactions';
    gaParams.event_action = 'continue';
  } else if (gaType === 'DISPLAY') {
    gaParams.event = 'recomonded_size';
    gaParams.event_category = 'product detail interactions';
    gaParams.event_action = 'recommended size display';
    gaParams.event_label = displayValue;
  } else if (gaType === 'WIDGET_VIEW') {
    gaParams.event = 'size_chart_interaction';
    gaParams.event_action = 'prime AI recommonded widget view';
  }
  console.log('🚀 ~ file: GTMdatalayer.js ~ line 809 ~ gtmPrimeAICTA ~ gaParams', gaParams);
  gtmDatalayerPushData(gaParams, 'gtmPrimeAICTA');
}

export function gtmEventPushAccountInteraction(pageName, action, label = '', customStoreAttr = '') {
  gtmDatalayerPushData(
    {
      action,
      label,
      page_name: pageName,
      page_type: 'my account screen',
      event: 'user_account_interactions',
      category: 'user account interactions',
      hybris_id: getUserUUID(),
      contains_store: customStoreAttr || getStoreName(),
      store_type: getStoreName(),
      ...getPageUserInfo()
    },
    'gtmEventPush'
  );

  // Segment push event
  segmentDatalayerPushData(
    {
      action,
      label,
      screen_name: pageName,
      // page_type: 'my account screen',
      event: 'Menu Option Clicked',
      clicked_menu_name: label,
      component_name: label,
      // hybris_id: getUserUUID(),
      // contains_store: customStoreAttr || getStoreName(),
      store_type: getStoreName(),
      // ...getPageUserInfo()
    },
    'gtmEventPush'
  );
}

export function gtmEventPushProductDetailsInteractions(
  action,
  label,
  productCode,
  productName,
  brandName,
  productCategory,
  productSubCategory
) {
  const { pageType, pageName } = getPageInfo(window.location.pathname || '', false, false);
  gtmEventPush({
    event: 'product_details_interactions',
    event_category: 'product details interactions',
    event_action: action,
    label: label,
    product_id: productCode,
    product_name: productName,
    product_brand: brandName,
    product_brick: productCategory,
    product_category: productSubCategory,
    page_name: pageName,
    page_type: pageType
  });
}

export function gtmDressToolViewEvent(type, dressToolDataObject) {
  const ga4AjioEnable = getGA4AJIOEnable(window?.__PRELOADED_STATE__?.flags);
  if (ga4AjioEnable) {
    gtmEventPush({
      event: type,
      dress_tool_ingress: dressToolDataObject?.dressToolTriggerPoint,
      screenname: dressToolDataObject?.screenname
    });
  }
}

export function gtmDressToolInteractEvent(type, dressToolDataObject) {
  const ga4AjioEnable = getGA4AJIOEnable(window?.__PRELOADED_STATE__?.flags);
  if (ga4AjioEnable) {
    gtmEventPush({
      event: type,
      dress_tool_ingress: dressToolDataObject?.dressToolTriggerPoint,
      screenname: dressToolDataObject?.screenname,
      category: dressToolDataObject?.category,
      action: dressToolDataObject?.action,
      label: dressToolDataObject?.label
    });
  }
}


export function rushAddressBarEvents(eventNameType, payload) {
  const ga4AjioEnable = getGA4AJIOEnable(window?.__PRELOADED_STATE__?.flags);
  if (ga4AjioEnable) {
    switch (eventNameType) {
      case "closeButtonClick":
        gtmEventPush({
          event: "back_button_clicked",
          event_category: "address_selection_screen_interactions",
          screen_name :"address selection"
        });
        segmentEventPush({
          event: "Back Button Clicked",
          page_name :"address selection"
        });
        break;

      case "locationNotAllowed":
        gtmEventPush({
          event: "location_disabled",
          event_category: "address_selection_screen_interactions",
          screen_name :"address selection"
        });
        segmentEventPush({
          event: "Location Disabled",
          page_name :"address selection"
        });
        break;

      case "locationEnableClick":
        gtmEventPush({
          event: "buttonTap",
          event_category: "buttonTap",
          event_action: "enable_location_clicked",
          screen_name :"address selection"
        });
        segmentEventPush({
          event: "Enable Location Clicked",
          page_name :"address selection"
        });
        break;

      case "searchNoResult":
        gtmEventPush({
          event: "search_no_result",
          event_category: "address_selection_screen_interactions",
          event_label: payload,
          screen_name :"address selection"
        });
        segmentEventPush({
          event: "Address Zsr Triggered",
          search_term:payload,
          page_name :"address selection"
        });
        break;

      case "searchBarCrossIconClicked":
        gtmEventPush({
          event: "search_cross_clicked",
          event_category: "address_selection_screen_interactions",
          screen_name :"address selection"
        });
        segmentEventPush({
          event: "Address Search Cross Clicked",
          page_name :"address selection"
        });
        break;

      case "selectRushAddress":
        gtmEventPush({
          event: "select_address",
          event_category: "address_selection_screen_interactions",
          event_action: payload?.source,
          event_label: payload?.pincode,
          screen_name :"address selection"
        });
        segmentEventPush({
          event: "Address Selected",
          address_selected_source:payload?.source,
          address_details:payload?.pincode,
          page_name :"address selection"
        });
        break;

      case "pinInteraction":
        gtmEventPush({
          event: "pin_interaction",
          event_category: "address_selection_screen_interactions",
          event_label: `${payload?.pincode} | ${payload?.lat} | ${payload?.long}`,
          screen_name :"address selection"
        });
        segmentEventPush({
          event: "pin interacted",
          address_details:payload?.pincode,
          lat_long:`${payload?.lat} | ${payload?.long}`,
          page_name :"address selection map"
        });
        break;

      case "confirmLocationButtonClick":
        gtmEventPush({
          event: "buttonTap",
          event_category: "buttonTap",
          event_action: "confirm_location_clicked",
          event_label: payload?.pincode,
          screen_name :"address selection"
        });
        segmentEventPush({
          event: "location confirmed",
          address_details:payload?.pincode,
          lat_long:`${payload?.lat} | ${payload?.long}`,
          page_name :"address selection map"
        });
        break;

      case "rushPdpRedirectImpression":
        gtmEventPush({
          event: "rush_pdp_redirect_impression",
          event_category: "rush_pdp_redirect_impression",
          event_action: "rush_pdp_redirect_impression",
          product_id:payload?.product_id,
          brick:payload?.brick,
          vertical:payload?.vertical
        });
        break;

      case "rushPdpRedirectClick":
        gtmEventPush({
          event: "rush_pdp_redirect_click",
          event_category: "rush_pdp_redirect_click",
          event_action: "rush_pdp_redirect_click",
          product_id:payload?.product_id,
          brick:payload?.brick,
          vertical:payload?.vertical
        });
        break;
        
        default:{}
    }
  }
}
export function getParentProduct(parentProduct){
  //console.log("Parent Product", parentProduct);
  return (parentProduct && parentProduct.productDetails ? {
          media_type : 'image',
          parent_product_id : parentProduct.productDetails?.code,
          parent_product_name: parentProduct.productDetails?.name,
          parent_product_mrp: parentProduct.productDetails?.wasPriceData?.value,
          parent_product_list_price: parentProduct.productDetails?.price?.value,
          //parent_product_offer_price: parentProduct.productDetails.id,
          //parent_product_position: parentProduct.id,
         // parent_product_rating: parentProduct.productDetails.id,
          parent_product_brick: parentProduct.productDetails?.brickCategory,
         // parent_product_vertical: parentProduct.productDetails.id,
        // parent_product_segment: parentProduct.id,
          parent_product_brand: parentProduct.productDetails?.brandName,
          catalog_id: parentProduct.productDetails?.catalogName,
        } : {});
}

export function getProductItem(product, token){
  return {
            //item_id: product.id,
            //item_name: product.name,
            //discount: Number(productDiscount) || 0,
            product_position: Number(product.position) || 0,
            product_brand: product.brand,
            //item_list_name: product.list || itemListName,
            //item_category: product.category,
            //item_variant: product.variant,            
            //coupon: product.coupon,
            //quantity: Number(product.quantity) || 1,
            product_id: product?.fnlColorVariantData?.colorGroup || product?.colorGroup,
            product_name: product.name,
            product_mrp : product.wasProductPrice,
            product_list_price: Number(product.price) || 0,
            product_offer_price: product.offerPrice,
            //product_category: product.category,
            //product_store_type: product.dimension23,
            product_segment: product.dimension36,
            //product_portfolio: product.dimension37,
            product_vertical: product.dimension38,
            product_brick: product.dimension39,
            product_tag: (() => {
              const baseTag = product.sticker_name || product.dimension89 || '';
              const urlParams = typeof window !== 'undefined' ? new URLSearchParams(window.location.search) : null;
              const trendTagName = urlParams?.get('isTrendWidget') === 'true' ? (urlParams?.get('tagName') || '') : '';
              return trendTagName ? `${baseTag}|||${trendTagName}` : baseTag;
            })(),
            //product_view_type: product.dimension41,
            product_rating: product.dimension46?.split('|')[0],            
            //available_quantity_deliverable_non_deliverable: product.dimension59,
            //segment_id_experiment_id: product.dimension60,
            //delivery_tag: product.dimension61,
            //product_level_edd: product.dimension66,
            //jio_ads_campaign_data: product.dimension161,
            //prod_jio_ads_listing: product.dimension162,
            //jio_ads_option_code: product.dimension163,
            //sticker_name: product.dimension165,
            //offer_name: product.dimension166,
            product_wishlisted_count: product.dimension167 || 0,
            //product_discount: product.dimension170,
            //product_trade_discount: product.dimension171,
            //product_size: product.dimension191,
            //...(userRelevancyFlag ? { product_store_type: getStoreName() + '|' + productListType } : {}),
            catalog_id: product.catalogName,
            similar_product_icon_available_flag: false,
            ...(product.dimension162 == 'yes') ? {
              ad_flag: true,
              ad_id: product.dimension161,
            } : {
              ad_flag:false,
              ad_source: 'no ads'
            },          
            ...(product.dimension166 && {
              rush_product_tag: product.dimension166
            }),
            priority_delivery_edd: product.dimension166,
            ...(token && {
              attribution_token: token
            }),
            ...(product?.adsFlag && Object.keys(product.adsFlag).length > 0 && { uclid: _get(product, 'adsFlag.config.uclid','')}),
            ...(product?.adsFlag && Object.keys(product.adsFlag).length > 0 && { client_id: _get(product, 'adsFlag.config.cid','')}),
            ...(product?.adsFlag && Object.keys(product.adsFlag).length > 0 && { seller_id: _get(product, 'sellerId','')}),
            ...(product?.adsFlag && Object.keys(product.adsFlag).length > 0 && { sku_id: _get(product, 'code','') }),
            ...(product?.adsFlag && Object.keys(product.adsFlag).length > 0 && { ad_source: _get(product, 'adsFlag.config.ad_source','') || 'osmos'}),
            ...(product?.adsFlag && Object.keys(product.adsFlag).length > 0 && { scl_id: _get(product, 'adsFlag.config.sclid','')}),
            ...(product?.adsFlag && Object.keys(product.adsFlag).length > 0 && { ad_id: _get(product, 'adsFlag.ad','')}),
            ...(product?.adsFlag && Object.keys(product.adsFlag).length > 0 && { ad_flag: true })
          };
}

export function getProductItemPDP(product, idx, campaignId, priority_delivery_EDD, isCheckUncheck){
  console.log("getProductItemPDP ::", product);
  if(!product) return {}

  const offerPrice = product.offerPrice ? product.offerPrice?.price : 
                      (product.potentialPromotions && product.potentialPromotions.length > 0 ? product.potentialPromotions[0].maxSavingPrice : '');
  let productListPrice;
  let productOfferPrice;
  let pdEdd;
  if(isCheckUncheck){
    productListPrice = Number(product && product?.priceInfo && product?.priceInfo?.netPrice && product?.priceInfo?.netPrice?.value);
    productOfferPrice = 'NA';
    pdEdd = priority_delivery_EDD && priority_delivery_EDD?.priorityDelivery && priority_delivery_EDD?.priorityDelivery?.deliveryDateTime;
  }

  const productImageOosFlag = (() => {
        const status = String(product?.stock?.stockLevelStatus ?? '').toLowerCase();
        if (status) return status !== 'outofstock';
        return false;
  })();
  
  return {
                
                media_type: 'image',
                product_position: Number(idx) || 0,
    product_brand:
      product.brandName || product.brandTypeName || product.fnlColorVariantData?.brandName,
                product_mrp: product.wasPriceData?.price ? product.wasPriceData?.price : product.wasPriceData?.value,
                product_list_price: Number(product.price?.value) || (isCheckUncheck && productListPrice && productListPrice) || 0,
                product_offer_price: Number(offerPrice) || (isCheckUncheck && productOfferPrice && productOfferPrice) ||0,            
                // product_id: product.code?.includes('_') ? product.code : (product.code.slice(0, -3) + "_" + (product.fnlColorVariantData?.colorGroup ? product.fnlColorVariantData?.colorGroup?.split('_')[1] : product.code?.split('_')[1])),
                product_id: product?.fnlColorVariantData?.colorGroup || product?.colorGroup,
                product_name: product.name,
                product_brick: product.brickNameText ? product.brickNameText : product.brickSubCategory,
                product_vertical: product.verticalNameText ? product.verticalNameText : product.brickName,
                product_segment: product.segmentNameText ? product.segmentNameText : product.brickCategory,                
                 ...(product.campaignId) && {
                  ad_flag : true,
                  ad_id : product.campaignId,
                },    
                ...(product.priority_delivery_edd && {
                  rush_product_tag: product.priority_delivery_edd
                }),
                priority_delivery_edd: product.priority_delivery_edd,
                ...(isCheckUncheck && pdEdd && {
                  event_priority_delivery_edd: pdEdd
                }),
                product_tag: product.product_tag,
                product_rating: product.averageRating ? product.averageRating : product.ratingsResponse?.aggregateRating?.averageRating,
                number_of_ratings_collected : product.ratingCount,
                catalog_id :product.catalogName,  
                product_oos_flag: !productImageOosFlag,
                ...(product?.adsData && { uclid: product?.adsData?.config?.uclid || ""}),
                ...(product?.adsData && { client_id: product?.adsData?.config?.cid || product?.osmosClientId || ""}) ,
                ...(product?.adsData && { ad_source: product?.adsData?.config?.adSource || "osmos" }) ,
                ...(product?.adsData && { scl_id: product?.adsData?.config?.sclid || ""}) ,
                sku_id: product?.adsData
                      ? product?.code
                      : product?.variantOptions?.[0]?.code || product?.code || '',   
                ...(product?.adsData && { seller_id: product?.seller_id || product?.sellerId || "" }) , 
                ...(product?.adsData && { ad_id: product?.adsData?.ad || "", ad_flag: true }) ,
                product_gift_with_purchase_flag: product?.offerPrice?.giftAvailable
      };
}

function getNonReturnableReason(product) {
  const isReturnable = product.prodData?.isReturnable ?? product.isReturnable;
  const isCatalogFraudReturnable =
    product.prodData?.isCatalogFraudReturnable ?? product.isCatalogFraudReturnable;
  if (isReturnable) return 'NA';
  return isCatalogFraudReturnable ? 'Coupon Applied' : 'Product Policy';
}

function getNonExchangableReason(product, isGSTSelected) {
  const isExchangeable = product.prodData?.isExchangeable ?? product.isExchangeable;
  const isCatalogFraudExchangeable = product.prodData?.isCatalogFraudExchangeable ?? product.isCatalogFraudExchangeable;
  const returnWindow = product.prodData?.returnWindow ?? product.returnWindow ?? 0;
  const gstBlocksExchange = isGSTSelected && isExchangeable && returnWindow > 0;
  if (gstBlocksExchange) return 'GST';
  if (!isExchangeable) return isCatalogFraudExchangeable ? 'Coupon Applied' : 'Product Policy';
  return 'NA';
}

export function getProductItemForCart(product, ProductArray, token){
  // console.log("cart product", product);

  //some scenarios has productData
  if(!product.prodData && product.productData){
     product.prodData = product.productData;
     delete product.productData;
  }

  const servicabilityInfo = product.prodData ? product.prodData?.servicabilityInfo : product.servicabilityInfo;
  const couponSavings = product.prodData ? product.prodData?.priceInfo?.couponSaving?.value : product.priceInfo?.couponSaving?.value;
  const productMrp = product.prodData ? product.prodData?.wasPriceData?.value : product.wasPriceData?.value;
  const productWithAttributeKey = (ProductArray || [])?.find(el => el?.skuId === product?.code) || {};
  let rushPdData = ProductArray && Array.isArray(ProductArray) && ProductArray.length>0 && ProductArray.filter((item) => item?.skuId === product?.code);  
  const plaItem = getPlaItemByProductCode(product?.code);
  const plaConfigClientId = getPlaAdsClientID(window?.__PRELOADED_STATE__)
  const product_list_price = product.prodData?.priceInfo?.netPrice?.value ?? product?.priceInfo?.netPrice?.value ?? product?.price;
  const baseProduct = product.prodData?.baseProduct || product.baseProduct;
  const productId = baseProduct ? baseProduct : product.id && product.variant ? `${product.id}_${product.variant}` : product.code && product.color ? `${product.code}_${product.color}` : product.id;
  const deliveryType = `${product.prodData?.deliveryMethod || product.deliveryMethod} | ${servicabilityInfo?.shippingAction || product.prodData?.deliverySLA || product.deliverySLA}`
  const isCompanion = isCompanionProduct(product?.prodData?.code || product?.code)
  return {
          product_id: productId,
          product_name: product.name,
          //discount: Number(product.discount) / (Number(product.quantity) || 1) || 0,
          product_poistion: Number(product.position) || 0,
          //product_brand: product.brand,
          //item_list_name: 'bag screen',
          //product_quantity: (Number(product.quantity) || 1),
          product_brick: product.prodData ? product.prodData?.brickSubCategory : product.brickSubCategory,
          product_segment: product.prodData ? product.prodData?.brickCategory : product.brickCategory,
          product_vertical: product.prodData? product.prodData?.brickName : product.brickName,
          //item_variant: product.variant,
          product_list_price: Number(product_list_price) / (Number(product.quantity) || 1) || 0,        
          product_offer_price: Number(product.prodData?.priceInfo?.specialPrice?.value ?? product.prodData?.priceInfo?.netPrice?.value ?? product.price) / (Number(product.quantity) || 1) || 0,
          product_brand : product.brand,  
          product_size: product.size,          
          product_quantity: Number(product.quantity) || 1,
          coupon_name: product.coupon,
        // available_quantity_deliverable_non_deliverable: product.dimension59,
          //segment_id_experiment_id: product.dimension60,
          //delivery_tag: product.dimension61,
          //delivery_edd: product.dimension66,
          product_source_store: isCompanion ? 'Companion App' : product.dimension23,
          store_name: isCompanion?.tenant_id ? isCompanion?.tenant_id : null,
          //offer_name: containsLuxe ? product.dimension82 : product.dimension166,
          product_mrp: Number(productMrp) || 0,
          ...(product.priorityDeliveryFee && {
            prioirty_delivery_fee : Number(product.priorityDeliveryFee).toFixed(1)
          }),
          //...(product.sticker_name && { sticker_name: product.sticker_name }),
          ...(product.priorityDeliveryEDD && {
            prioirty_delivery_edd : product.priorityDeliveryEDD
          }),
          product_gift_with_purchase_flag:
            servicabilityInfo?.isGiftProduct ||
            Number(product?.prodData?.giftQuantity || product?.giftQuantity || product?.giftProductsCount || 0) > 0,
          product_oos_flag: (product.dimension59 == 0 ),
          product_return_exhange_window: product.prodData?.returnWindow ?? product.returnWindow ?? 0,
          product_return_window: product.prodData?.returnWindow ?? product.returnWindow ?? 0,
          product_exchange_window: product.prodData?.returnWindow ?? product.returnWindow ?? 0,
          product_servicability:servicabilityInfo?.servicability,
          product_supercash_earned: product.superCashData?.product_supercash_earn,
          delivery_type: deliveryType,
          delivery_type_selected: ['PRIORITY', 'RUSH'].includes(product.prodData?.deliveryMethod || product.deliveryMethod),
          standard_delivery_edd: servicabilityInfo?.promiseShippingDate,
          catalogue_id: product.prodData?.catalogName || product.catalogName,
          product_coupon_savings: Number(couponSavings) || 0,
          product_tag: product.sticker_name || product.prodData?.productTag || product.productTag,  
          is_subscription: product?.isMembershipArticle,
          // ...(product.priority_delivery_sla_tag && {
          //   priority_delivery_sla_tag: product.priority_delivery_sla_tag
          // })
          ...((product.pincode || ProductArray && ProductArray[0]?.pincode) && { pincode: product.pincode || ProductArray && ProductArray[0]?.pincode }),
          ...((product.priorityDeliveryFee || rushPdData && Array.isArray(rushPdData) && rushPdData?.[0]?.priorityDeliveryFee) && {
            product_priority_delivery_fee: Number(product.priorityDeliveryFee || rushPdData && Array.isArray(rushPdData) && rushPdData?.[0]?.priorityDeliveryFee).toFixed(1)
          }),
          ...((product.priorityDeliveryEDD || rushPdData && Array.isArray(rushPdData) && rushPdData?.[0]?.priorityDeliveryEDD) && {
            priority_delivery_EDD: product.priorityDeliveryEDD || rushPdData && Array.isArray(rushPdData) && rushPdData?.[0]?.priorityDeliveryEDD
          }),
          ...((product.priority_delivery_sla_tag || rushPdData && Array.isArray(rushPdData) && rushPdData?.[0]?.priority_delivery_sla_tag) && {
            priority_delivery_sla_tag: product.priority_delivery_sla_tag || rushPdData && Array.isArray(rushPdData) && rushPdData?.[0]?.priority_delivery_sla_tag
          }),
          ...((product.rushDeliveryFee || rushPdData && Array.isArray(rushPdData) && rushPdData?.[0]?.rushDeliveryFee) && {
            product_rush_delivery_fee: Number(product.rushDeliveryFee || rushPdData && Array.isArray(rushPdData) && rushPdData?.[0]?.rushDeliveryFee).toFixed(1)
          }),
          ...((product.rushDeliveryEDD || rushPdData && Array.isArray(rushPdData) && rushPdData?.[0]?.rushDeliveryEDD) && {
            rush_delivery_EDD: product.rushDeliveryEDD || rushPdData && Array.isArray(rushPdData) && rushPdData?.[0]?.rushDeliveryEDD
          }),
          ...((product.rush_delivery_sla_tag || rushPdData && Array.isArray(rushPdData) && rushPdData?.[0]?.rush_delivery_sla_tag) && {
            rush_delivery_sla_tag: product.rush_delivery_sla_tag || rushPdData && Array.isArray(rushPdData) && rushPdData?.[0]?.rush_delivery_sla_tag
          }),
          ...((productWithAttributeKey.search_attribution || token) && {
            attribution_token: productWithAttributeKey.search_attribution || token
          }),
          ...(product.hasOwnProperty('is_gst_eligible') && {
            is_gst_eligible: product.is_gst_eligible
          }),
          sku_id: product?.code,
          ...(plaItem?.productCode && {
                sku_id: plaItem?.productCode,
                seller_id: plaItem?.seller_id,
                client_id: plaItem?.client_id || plaConfigClientId || ""
          })
        };
}

export function getCartItemProperty(cart, isAssuredGifts, internalWallets){
  //console.log("Wallet ", internalWallets);

  let wallet_cash_balance = 0;
  let wallet_points_applicable = 0;
  let wallet_points_balance = 0;
  let wallet_points_used = 0;

  let rone_balance=0;
  let rone_balance_used = 0;
  let rone_points_applicable = 0;    

  if(internalWallets && internalWallets.length > 0){
    //get wallet information
    let roneWallet = internalWallets.find(item => item.type == 'RELIANCE_ONE_WALLET');
    let cashWallet = internalWallets.find(item => item.name == 'AJIO_CASH_POINTS_WALLET');
    let subWallets = cashWallet?.subWallets?.length > 0 ? cashWallet?.subWallets[0] : null;

    rone_balance= roneWallet?.availableAmount;
    rone_balance_used = '';
    rone_points_applicable = roneWallet?.amount;      

    wallet_cash_balance = cashWallet?.availableAmount; 
    wallet_points_applicable = subWallets?.amount;
    wallet_points_balance = '';
    wallet_points_used = '';

  }
 
  return {
        ...cart && cart?.totalUnitCount >0 && {
          cart_id : cart?.id,
          bag_total:  Number(cart?.orderSummary?.bagTotal?.value || 0), 
          bag_assured_gift_flag : isAssuredGifts?.cartAssuredGifts === 'ON',
          bag_price_update_callout: '',
          bag_item_count : cart?.totalUnitCount || 0,   
          is_bag_merged: cart?.restoredProducts ? true : false,       
          bag_savings: Number(cart?.orderSummary?.bagDiscount?.value || 0), 
          coupon_savings: Number(cart?.orderSummary?.couponSaving?.value || 0), 
          order_total: Number(cart?.orderSummary?.orderTotal?.value || 0),     
          platform_fee: Number(cart?.orderSummary?.convenienceFee?.total?.netAmount?.value || 0), 
          total_savings: Number(cart?.orderSummary?.totalSaving?.value || 0),
          delivery_fee:  Number(cart?.orderSummary?.deliveryCharge?.value),
        },
        ...internalWallets && internalWallets.length >0 && {
          rone_balance: Number(rone_balance),
          //rone_balance_used: Number(rone_balance_used),
          rone_points_applicable: Number(rone_points_applicable),        
          wallet_cash_balance: Number(wallet_cash_balance),
          wallet_points_applicable: Number(wallet_points_applicable),
          //wallet_points_balance: Number(wallet_points_balance),
        // wallet_points_used: Number(wallet_points_used),
        // delivery_type_selected: cart?.deliveryInfo?.deliveryModeValue,
        }
  }
}

function checkEntranceFlag(){
   if (document.referrer) {
      // Referrer exists
      if (!(document.referrer.includes("ajio.com") || document.referrer.includes("localhost"))) {
        return true;
      }else 
        return false;

    } else {
      // Referrer does not exist
      return true;
    }
}

function getPreviousScreenName(){

  if(document.referrer){
    const pageInfo = getPageInfo(document.referrer);
    return pageInfo?.pageName || pageInfo?.pageType;
  }
  return "";
}

export function getProductItemAjioGram(product, position){
  //console.log("getProductItemPDP ::", product);
  if(!product) return {}

  return {      
           
         //media_type: 'image',
          product_position: Number(position) || 0,
          product_brand: product.fnlColorVariantData?.brandName,              
          product_mrp: product.wasPriceData?.price ? product.wasPriceData?.price : product.wasPriceData?.value,
          product_list_price: Number(product.price?.value) || 0,
          product_offer_price: product.offerPrice?.price,               
          product_id: product.id,
          product_name: product.name,    
                           
      };
}

export function segmentPageView(page_name, page_type, env , otherOptions , segmentProps){

    const eventName = 'pageload';
    const { store = 'AJIO', serviceName = '', ...restOtherOptions } = otherOptions;
    const { 
      cart= {}, 
      order={},
      isAssuredGifts='', 
      internalWallets = {}, 
      coachmark_impression= '', 
      search_term='', 
      search_type='', 
      quick_filter_count='',
      quick_filter_name='',
      ads_enabled_screen_flag='',
      best_coupon_name='',
      best_coupon_discount='',
      current_experience='',
      number_of_ratings_collected='',
      number_of_color_variant_avialable='',
      bag_primary_cta_name='',
      bag_primary_cta_state= '',        
      bag_secondary_cta_name= '',
      bag_secondary_cta_status= '',
      ajioWalletData={},
    } = segmentProps;
    restOtherOptions.store_type = store;
    const storeName = getStoreName();

    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);   

    const copilotRedirectionValue = urlParams?.get('plp_source_details') ?? '';
    const isRedirectedFromCopilot = page_type === 'plp screen' && copilotRedirectionValue === 'ai_assistant_widget';

    let visualFilterCount = '';
    let visualFiltersArray = null;
    const plpPageTypes = ['plp screen', 'fleek curated plp screen '];
    if (plpPageTypes.includes(page_type)) {
      const facetsState = window?.__PRELOADED_STATE__?.facets || {};
      const { visualFilters = [], quickFilters = [], visualFiltersState = '' } = facetsState;
      const quickFilterValuesCount = (quickFilters || []).reduce((count, filter) => {
        if (filter?.code === 'tags' || filter?.code === 'sla') {
          return count + (Array.isArray(filter.values) ? filter.values.length : 0);
        }
        return count;
      }, 0);
      if (visualFilters.length > 0 || quickFilterValuesCount > 0) {
        visualFilterCount = `${visualFilters.length}|${quickFilterValuesCount}`;
        visualFiltersArray = [];
        visualFilters.forEach((filter, index) => {
          const isSelected = visualFiltersState.includes(`${filter.defaultDisplayName}:T`);
          visualFiltersArray.push({
            section: 0,
            position: index + 1,
            facet_key: filter.defaultDisplayName,
            facet_value: filter.defaultDisplayName,
            value: filter.defaultDisplayName,
            selection_state: isSelected ? 'selected' : 'non_selected',
            filterid: filter.filterId || ''
          });
        });
        const INLINE_TAG_CODES = new Set(['tags', 'sla']);
        const allfacetsItems = facetsState.currentFacets?.allfacetsItems || [];
        let qfPosition = 1;
        quickFilters.forEach(filter => {
          if (INLINE_TAG_CODES.has(filter.code)) {
            const matchingFacet = allfacetsItems.find(f => f.code === filter.code);
            const values = Array.isArray(filter.values) ? filter.values : [];
            values.forEach(valueCode => {
              const facetValue = matchingFacet?.values?.find(v => v.code === valueCode);
              visualFiltersArray.push({
                section: 1,
                position: qfPosition++,
                facet_key: filter.code,
                facet_value: valueCode,
                value: facetValue?.name || valueCode,
                selection_state: 'non_selected',
                filterid: ''
              });
            });
          } else {
            visualFiltersArray.push({
              section: 1,
              position: qfPosition++,
              facet_key: filter.code,
              facet_value: Array.isArray(filter.values) ? filter.values.join('|') : '',
              value: filter.name || filter.code,
              selection_state: 'non_selected',
              filterid: ''
            });
          }
        });
      }
    }

    const screenViewedToken = getValidAttributionToken();
    const resolvedPageCategory = getStoredPageCategory();
    segmentDatalayerPushData(
      {
        event: "Screen Viewed",
        screen_name: page_name,
        screen_source: isRedirectedFromCopilot ? copilotRedirectionValue : page_type,
        ...restOtherOptions,
        ...getPageUserInfoForSegment(),
        store_type: getStoreName(),
        ...screenViewedToken && { attribution_token: screenViewedToken },
        ...(resolvedPageCategory && { page_category: resolvedPageCategory }),
        ...ads_enabled_screen_flag && { ads_enabled_screen_flag: ads_enabled_screen_flag },
        ...cart && cart?.totalUnitCount > 0 && getCartItemProperty(cart, isAssuredGifts, internalWallets),
        ...best_coupon_discount && { best_coupon_discount: best_coupon_discount },
        ...best_coupon_name && { best_coupon_name: best_coupon_name },
        ...coachmark_impression && { coachmark_impression: coachmark_impression },               
        ...order && order?.orderSummary && {
          order_id : order.id,
          order_total: order?.orderSummary?.bagTotal?.value,       
          bag_item_count : order?.totalItems,               
          bag_savings: order?.orderSummary?.bagDiscount?.value, 
          coupon_savings: order?.orderSummary?.couponSaving?.value, 
          order_total: order?.orderSummary?.orderTotal?.value,     
          platform_fee: order?.orderSummary?.convenienceFee?.total?.netAmount?.value, 
          total_savings: order?.orderSummary?.totalSaving?.value,
          rone_balance: order?.relianceOneEarnedAmount?.value,    
          delivery_fee: order?.orderSummary?.deliveryCharge?.value,        
          payment_type: order?.payment_type,       
          delivery_fee: order?.orderSummary?.deliveryCharge?.value,
        },
        ...ajioWalletData && {
          //rone_balance: Number(rone_balance),
          //rone_balance_used: Number(rone_balance_used),
          //rone_points_applicable: Number(rone_points_applicable),        
          wallet_cash_balance: ajioWalletData?.ajioWalletBalanceDet?.totalWalletBalance?.total,
          wallet_points_balance: ajioWalletData?.ajioWalletBalanceDet?.totalWalletBalance?.totalPoints,
          //wallet_points_applicable: Number(wallet_points_applicable),        
          //wallet_points_used: Number(wallet_points_used),
        },
        ...getCartItemProperty(cart, isAssuredGifts, internalWallets),
        ...best_coupon_discount && { best_coupon_discount: best_coupon_discount },
        ...best_coupon_name && { best_coupon_name: best_coupon_name },
        ...coachmark_impression && { coachmark_impression: coachmark_impression },     
        ...number_of_ratings_collected && {number_of_ratings_collected : number_of_ratings_collected},  
        ...number_of_color_variant_avialable && {number_of_color_variant_avialable: number_of_color_variant_avialable},        
        is_entrance_flag: checkEntranceFlag(),
        //number_of_color_variant_available: '',
        //number_of_rating_collected: '',       
        page_url: window.location.href,
        ...current_experience && { persona_store_type: current_experience || '' },        
        //priority_delivery_fee: '',
        ...quick_filter_count && { quick_filter_count: quick_filter_count },
        ...quick_filter_name && { quick_filter_name: quick_filter_name },
        ...visualFilterCount && { visual_filter_count: visualFilterCount },
        ...visualFiltersArray && { filters: visualFiltersArray },
        ...urlParams.get('query') && {raw_query: urlParams.get('query') },        
        //return_processing_fee: '',       
        screen_title: document.title,
        ...search_term && { search_term: search_term },
        ...search_type && { search_type: search_type },
        ...page_type=='bag screen' && {
          bag_primary_cta_name: bag_primary_cta_name,
          bag_primary_cta_state: bag_primary_cta_state,        
          bag_secondary_cta_name: bag_secondary_cta_name,
          bag_secondary_cta_status: bag_secondary_cta_status,
        }
       
       
      },
      'gtmPagePush'
    );
}
